import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import './Event.css';

import { AddNewPlayer, ItemPicker, Modal, ComboBox, PhotoAddModal, WhoToSeePicker, TagView, ConfirmModal, ChatTextBox, MediaItem, EmptyState, LoadingState } from './Common';
import { GamePlaceField } from './GMC';
import SupotsuCalender from './SupotsuCalender';
import GroupEvents, { EventCalenderView, EventAttandence } from './GroupEvents';
import { CreateMessasingGroup, CreateMessasingModal } from '../pages/Chat';
import Redirect from 'react-router/Redirect';
import { AddPlayer, playerLimit } from './Squads';

const { moment, $ } = window;

export default class EventView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      view: "initial"
    }
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  getSingleTeamTeams = (team) => {
    const _list = [];
    const _teams = FakeData.listify(team.squads.current);
    var _thisTeam = team;
    delete _thisTeam.name;
    //console.log(_teams)
    for (let i = 0; i < _teams.length; i++) {
      const item = team.squads.current[i];
      var _team = {};
      for (const key in _thisTeam) {
        if (_thisTeam.hasOwnProperty(key)) {
          const prop = _thisTeam[key];
          if (key === "name" || key === "squads" || key === "activeSquad") {
            continue;
          } else {
            _team[key] = prop;
          }
        }
      }
      //delete _team.name;
      _team['name'] = item.name + " " + item.age;
      _team['activeSquad'] = item;
      //console.log(item.name+" "+item.age)
      _team['players'] = FakeData.listify(item.players);

      if (FakeData.inArray(_team, _list)) {
        continue;
      } else {
        _list.push(_team)
      }
    }
    /*.forEach((item,i)=>{
      const _team = team;
      //console.log(item)
      _team.name = item.name+" "+item.age;
      _team.players = FakeData.listify(item.players);
      _list.push(_team)
    });*/

    return _list;
  }

  render() {
    const { profile, isDashboard, eventToType, viewEvents, events } = this.props;
    let hasTeams = viewEvents ? false : eventToType === "T" ? true : (FakeData.getData("yoo").id !== null && FakeData.getData("yoo").ownTeams.length === 0) ? false : true;
    const { } = this.state;
    hasTeams = !profile.isAdmin ? false : hasTeams;
    const teams = eventToType === "T" ? this.getSingleTeamTeams(profile) : (eventToType === "F" || eventToType === "P") ? FakeData.listify(FakeData.getData("yoo").ownTeams) : profile.teams.current;

    return (
      <div className={!isDashboard?"create-event-view sp-flex-width":"create-event-view"} style={{width:!isDashboard?"":"100%",margin:!isDashboard?"0px":""}}>
        {!hasTeams && !isDashboard &&
          <GroupEvents BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} isPage={true} pageType={eventToType} profile={profile} users={[]} events={events} isAdmin={profile.isAdmin} />
        }

        {hasTeams && isDashboard &&
          <EventCreateView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} teams={teams} {...this.props} eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} profile={this.props.profile} />
        }

        {(this.state.view === "initial" && hasTeams && !isDashboard) &&
          <EventListView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} active={"Events"} isDashboard={isDashboard ? isDashboard : false} hasTeams={hasTeams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} setView={(view) => {
            this.setState({
              view: view
            });
          }} events={this.props.events} profile={this.props.profile}>
            <EventCalenderView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} isAdmin={profile.isAdmin} date={this.state.date} events={events} />
          </EventListView>
        }

        {(this.state.view === "events" && hasTeams && !isDashboard) &&
          <EventListView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} active={"Create"} isDashboard={isDashboard ? isDashboard : false} hasTeams={hasTeams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} setView={(view) => {
            this.setState({
              view: view
            });
          }} events={this.props.events} profile={this.props.profile}>
            <GroupEvents BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} isCreate={true} isPage={true} pageType={eventToType} profile={profile} users={[]} events={events} isAdmin={profile.isAdmin} />
          </EventListView>
        }

        {(this.state.view === "create" && hasTeams && !isDashboard) &&
          <EventCreateView BlockedBySystem={this.props.BlockedBySystem} BlockedByYou={this.props.BlockedByYou} BlockedForYou={this.props.BlockedForYou} withBackBtn={isDashboard ? false : true} teams={teams} {...this.props} eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} profile={this.props.profile} setView={(view) => {
            this.setState({
              view: "initial"
            });
          }} />
        }
      </div>
    );
  }
}

class EventListView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: this.props.active ? this.props.active : "Events",
      tabs: ["Create", "Events", "Team Events"]
    }
  }

  setTab(item) {
    this.setState({
      active: item
    });
    if (item === "Create") {
      this.props.setView("events")
    } else if (item === "Team Events") {
      this.props.setView("create")
    } else {
      this.props.setView("initial")
    }
  }

  render() {
    const { profile, isDashboard, hasTeams, children } = this.props;
    const { } = this.state;
    return (
      <div className="event-list-view">
        <div className="event-list-view-tabs">
          {
            this.state.tabs.map((item, i) => {
              return (
                <div key={i} className={(this.state.active === item) ? "event-list-view-tab active" : "event-list-view-tab"} onClick={() => {
                  this.setTab(item)
                }}>{item}</div>
              )
            })
          }
        </div>
        <div className="event-list-view-content">
          {children}
        </div>
      </div>
    );
  }
}

class EventCreateView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: "Create",
      tabs: (this.props.eventToType !== "T") ? ["Create", "Attendence / Availability", "Manage"] : ["Create", "Attendence / Availability", "Manage", "Players", "Your Events"],
      createTab: "Create Single Event",
      manageTab: "Edit Events",
      isEmailing: false,
      sendTo: "",
      isEditting: false,
      msgTab: "Messages",
      team: (this.props.eventToType === "T") ? this.props.eventToID : 0,
      data: this.props.events,
      currentEvent: (FakeData.listify(this.props.events).length === 0) ? null : FakeData.listify(this.props.events)[0],
      type: "",
      date: "",
      calTab: "Training",
      editEvent: this.props.events[0],
      isEdittingEvent: false,
      eventToEdit: null,
      isDeletingEvent: false,
      eventToDelete: null,
      isDeletingInvite: false,
      itemToDelete: null,
      isDeletingPlayer: false,
      playerToDelete: null,
      currentTeam: this.props.teams[0] ? this.props.teams[0] : { name: "", players: [] }
    }

    this.onDateSelect = this.onDateSelect.bind(this)
    this.onTeamSelect = this.onTeamSelect.bind(this)
    this.onTypeSelect = this.onTypeSelect.bind(this)
    this.onEventSelect = this.onEventSelect.bind(this)
    this.addPlayerToEvent = this.addPlayerToEvent.bind(this)
  }

  setTab(item) {
    this.setState({
      active: item
    })
  }

  onTeamSelect(team) {
    this.setState({
      team: team.id,
      currentTeam: team
    });
    setTimeout(() => this.filter(), 1000)
  }

  onTypeSelect(type) {
    this.setState({
      type: (type === "") ? "" : type
    });
    setTimeout(() => this.filter(), 1000)
  }

  onDateSelect(date) {
    this.setState({
      date: date
    });
    setTimeout(() => this.filter(), 1000)
  }

  onEventSelect(event) {
    this.setState({
      currentEvent: event
    });
    setTimeout(() => this.filter(), 1000)
  }

  onEventEditSelect(event) {
    this.props.events.forEach((item, i) => {
      if (item.name.toLowerCase() === event.toLowerCase()) {
        this.setState({
          editEvent: item
        })
        return true;
      }
    })
  }

  filter() {
    const arr = []
    this.props.events.forEach((item, i) => {
      if ((item.type.toLowerCase().indexOf(this.state.type.toLowerCase()) > -1) || (item.team.id === this.state.team) && (item.date === this.state.date)) {
        //console.log("found");
        arr.push(item)
        this.setState({
          data: arr
        });
      }
    })
  }

  addPlayerToEvent(player, isManage) {
    if (!player || !player.id) {
      return
    }
    const _that = this
    const dataTo = {
      userToId: this.props.eventToID,
      eventId: (isManage) ? this.state.editEvent.id : this.state.currentEvent.id,
      playerId: player.id,
      inviteId: player.userId
    }

    //console.log(dataTo);
    FakeData.post("/addPlayerToEvent.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/addPlayerToEvent.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not add player";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          return
        }

        if (isManage) {
          _that.state.editEvent.players.push(player)
          _that.setState({
            editEvent: _that.state.editEvent
          });
        } else {
          _that.state.currentEvent.players.push(player)
          _that.setState({
            currentEvent: _that.state.currentEvent
          });
        }

      }),
      error: ((err) => {

      })
    }, true, "Player added!", ((res) => {

    }))
  }

  getEventNames(events) {
    const arr = []
    events.forEach((item, i) => {
      if (item.name !== "") {
        arr.push(item.name)
      }
    })
    return arr
  }

  _removePlayer(item) {
    const _that = this
    const dataTo = {
      eventId: this.state.currentEvent.id,
      playerId: item.id,
      inviteId: item.userId
    }

    //console.log(dataTo);
    FakeData.post("/removeEventPlayer.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEventPlayer.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove player";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeletingPlayer: false,
            playerToDelete: null
          });
          return
        }
        const index = _that.state.currentEvent.players.indexOf(item)
        _that.state.currentEvent.players.splice(index, 1)
        _that.setState({
          currentEvent: _that.state.currentEvent,
          isDeletingPlayer: false,
          playerToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "Player removed!", ((res) => {

    }))
  }

  removePlayer(item) {
    const _that = this
    const dataTo = {
      player: item,
      user: FakeData.getData("yoo")
    }

    //console.log(dataTo);
    FakeData.post("/removeTeamPlayer.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeTeamPlayer.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove player";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeletingPlayer: false,
            playerToDelete: null
          });
          return
        } else {
          FakeData.alert("Player removed!")
        }

        const index = _that.state.currentTeam.players.indexOf(item)
        _that.state.currentTeam.players.splice(index, 1)
        _that.setState({
          currentTeam: _that.state.currentTeam,
          isDeletingPlayer: false,
          playerToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "", ((res) => {

    }))
  }

  removeInvite(item) {
    const _that = this
    const dataTo = {
      eventId: this.state.editEvent.id,
      inviteId: item.user.id
    }

    //console.log(dataTo);
    FakeData.post("/removeEventInvite.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEventInvite.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove user";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeletingInvite: false,
            itemToDelete: null
          });
          return
        }
        const index = _that.state.editEvent.invites.indexOf(item)
        _that.state.editEvent.invites.splice(index, 1)
        _that.setState({
          editEvent: _that.state.editEvent,
          isDeletingInvite: false,
          itemToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "User removed!", ((res) => {

    }))
  }

  removeEvent(event) {
    const _that = this
    const dataTo = {
      eventId: event.id
    }

    //console.log(dataTo);
    FakeData.post("/removeEvent.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEvent.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove event";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeletingEvent: false,
            eventToDelete: null
          });
          return
        }
        const index = _that.state.data.indexOf(event)
        _that.state.data.splice(index, 1)
        _that.setState({
          data: _that.state.data,
          isDeletingEvent: false,
          eventToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "Event removed!", ((res) => {

    }))
  }

  render() {
    const eventNames = this.getEventNames(this.props.events)
    if (this.state.createTab === "Create Game") {
      return (
        <Redirect to={{
          pathname: "/gmc",
          state: { from: window.location.href }
        }} />
      )
    }

    const team = !this.state.currentTeam.id ? this.props.teams[0] : this.state.currentTeam;
    return (
      <div className="event-list-view">
        <div className="event-list-view-tabs">
          {
            this.state.tabs.map((item, i) => {
              if (item === "Your Events" && !this.props.withBackBtn) {
                return null;
              }
              return (
                <div key={i} className={(this.state.active === item) ? "event-list-view-tab active" : "event-list-view-tab"} onClick={() => {

                  if (item === "Your Events" && this.props.withBackBtn) {
                    this.props.setView(item)
                  } else {
                    this.setTab(item)
                  }
                }}>{item}</div>
              )
            })
          }
        </div>
        <div className="event-list-view-content">
          {(this.state.active == "Create") &&
            <EventViewSplitPane isExtended={true} active={this.state.createTab} items={["Create Single Event", "Create Recurring Event", "Create Game"]} setView={(d) => {
              this.setState({
                createTab: d
              });
            }}>
              {(this.state.createTab === "Create Single Event") &&
                <EventViewCreateForm1 {...this.props} eventToType={this.props.eventToType} eventToID={this.props.eventToID} onAfterAdd={() => {
                }} />
              }

              {(this.state.createTab === "Create Recurring Event") &&
                <EventViewCreateForm2 {...this.props} eventToType={this.props.eventToType} eventToID={this.props.eventToID} onAfterAdd={() => {
                }} />
              }
              {(this.state.createTab === "Create Game") &&
                <LoadingState isShown={true} text={"Please wait..."} />
              }
            </EventViewSplitPane>
          }
          {(this.state.active == "Attendence / Availability") &&
            <div className="events-default-view">
              <EventAttandence profile={this.props.profile} events={this.props.events} isParent={false} isAdmin={this.props.profile.isAdmin} teams={this.props.teams} />
            </div>
          }
          {(this.state.active == "Manage") &&
            <EventViewSplitPane active={this.state.manageTab} items={["Edit Events"/*, "Edit Invitees"*/]} setView={(d) => {
              this.setState({
                manageTab: d
              });
            }}>
              {(this.state.manageTab === "Edit Events") &&
                <div className="events-default-view">
                  <EventsFilter onDateSelect={this.onDateSelect} teams={this.props.teams} onTypeSelect={this.onTypeSelect} onTeamSelect={this.onTeamSelect} />
                  <div className="event-edit">
                    {
                      this.props.events.map((item, i) => {
                        return (
                          <div className="event-edit-item" key={i}>
                            <span>{item.name + " | " + item.date}</span>
                            {!item.isGame &&
                              <div className="event-edit-item-actions">
                                <div className="manage_event_edit" onClick={() => {
                                  this.setState({
                                    isEdittingEvent: true,
                                    eventToEdit: item
                                  });
                                }}>Edit</div>
                                <div className="manage_event_delete" onClick={() => {
                                  this.setState({
                                    isDeletingEvent: true,
                                    eventToDelete: item
                                  });
                                }}>Delete</div>
                              </div>
                            }
                            {item.isGame &&
                              <div className="event-edit-item-actions">
                                <Link className="manage_event_edit" to={{ pathname: "/gmc" }}>Open GMC</Link>
                              </div>
                            }
                          </div>
                        )
                      })
                    }
                  </div>
                  {
                    //eventToType={this.props.eventToType} eventToID={this.props.eventToID}
                  }
                  {this.state.eventToEdit !== null &&
                    <EditEventModal {...this.props} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={(this.state.isEdittingEvent && this.state.eventToEdit !== null) ? true : false} event={this.state.eventToEdit} onClose={() => {
                      this.setState({
                        isEdittingEvent: false,
                        eventToEdit: null
                      });
                    }} />
                  }
                  {this.state.eventToDelete !== null &&
                    <ConfirmModal message="Are you sure you want to remove this event?<br/>" isOpen={this.state.isDeletingEvent} data={this.state.eventToDelete}
                      onOkay={(data) => {
                        this.removeEvent(data)
                      }}
                      onCancel={() => {
                        this.setState({
                          isDeletingEvent: false,
                          eventToDelete: null
                        })
                      }} />
                  }
                </div>
              }

              {(this.state.manageTab === "Edit Invitees") &&
                <div className="events-default-view">
                  <EventsFilter onPlayerAdd={(player) => this.addPlayerToEvent(player, true)} teams={this.props.teams} canAddPlayer="true" canAddPlayer="true" canSelectEvent="true" events={eventNames} onDateSelect={this.onDateSelect} onEventSelect={(e) => this.onEventEditSelect(e)} onTeamSelect={this.onTeamSelect} />
                  <div className="event-edit">
                    {this.state.editEvent &&
                      this.state.editEvent.invites.map((item, i) => {
                        return (
                          <div className="event-edit-item" key={i}>
                            <span>{item.user.name + " | " + this.state.editEvent.name}</span>
                            <div className="event-edit-item-actions">
                              <div className="manage_event_message" onClick={() => {
                                const _that = this
                                FakeData.setData("eventMailTo", item.user);
                                setTimeout(() => {
                                  _that.setState({
                                    isEmailing: true
                                  });
                                }, 1000)
                              }}>Message</div>
                              <div className="manage_event_delete" onClick={() => {
                                this.setState({
                                  isDeletingInvite: true,
                                  itemToDelete: item
                                })
                              }}>Delete</div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>

                  {this.state.itemToDelete !== null &&
                    <ConfirmModal message="Are you sure you want to remove this user?<br/>" isOpen={this.state.isDeletingInvite} data={this.state.itemToDelete}
                      onOkay={(data) => {
                        this.removeInvite(data)
                      }}
                      onCancel={() => {
                        this.setState({
                          isDeletingInvite: false,
                          itemToDelete: null
                        })
                      }} />
                  }
                </div>
              }
            </EventViewSplitPane>
          }
          {(this.state.active == "Calendar") &&
            <EventViewSplitPane hasSuffix="true" suffix="Calendar" active={this.state.calTab} items={["Training", "Social", "Meeting"]} setView={(d) => {
              this.setState({
                calTab: d
              });
              this.onTypeSelect(d)
            }}>
              <div className="events-default-view">
                <EventsFilter eventToType={this.props.eventToType} eventToID={this.props.eventToID} toEvent="true" events={this.props.events} isCalender="true" canAddPlayer="true" onDateSelect={this.onDateSelect} onTypeSelect={this.onTypeSelect} onTeamSelect={this.onTeamSelect} />
                <EventCalenderView isCalendar={true} isAdmin={true} date={this.state.date} events={this.props.events} />
              </div>
            </EventViewSplitPane>
          }
          {(this.state.active == "Players") &&
            <div className="events-default-view">
              <EventsFilter currentTeam={team} onPlayerAdd={(player) => this.addPlayerToEvent(player, false)} teams={this.props.teams} players={this.state.currentEvent ? this.state.currentEvent.players : []} isPlayerView="true" canAddPlayer="true" onDateSelect={this.onDateSelect} onTypeSelect={this.onTypeSelect} onTeamSelect={this.onTeamSelect} />
              <table className="event-players">
                <thead>
                  <tr>
                    <td>Player Name</td>
                    <td>DOB</td>
                    <td>Position</td>
                    <td>Number</td>
                    <td>Manage</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.currentTeam &&
                    FakeData.listify(team.players).map((item, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ paddingLeft: "10px" }} className="clickable" onClick={() => {
                            const _that = this
                            FakeData.setData("eventMailTo", item);
                            setTimeout(() => {
                              _that.setState({
                                isEmailing: true
                              });
                            }, 1000)
                          }}>{item.name}</td>
                          <td>{item.user.dob}</td>
                          <td>{item.position}</td>
                          <td>{item.number}</td>{/*
                          <td className="clickable">{this.state.currentEvent.name}</td>
                          <td className="clickable">View</td>*/}
                          <td className="event-edit-item-actions" style={{ width: "100%" }}>
                            <div className="player_event_delete" style={{ backgroundPosition: "center center" }} onClick={() => {
                              this.setState({
                                isDeletingPlayer: true,
                                playerToDelete: item
                              })
                            }}></div>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
              {this.state.playerToDelete !== null &&
                <ConfirmModal message="Are you sure you want to remove this player?<br/>" isOpen={this.state.isDeletingPlayer} data={this.state.playerToDelete}
                  onOkay={(data) => {
                    this.removePlayer(data)
                  }}
                  onCancel={() => {
                    this.setState({
                      isDeletingPlayer: false,
                      playerToDelete: null
                    })
                  }} />
              }
            </div>
          }
          {(this.state.active == "Messaging") &&
            <EventViewSplitPane active={this.state.msgTab} items={["Applications", "Team", "Parents", "Messages", "Groups", "Emails"]} setView={(d) => {
              this.setState({
                msgTab: d
              });
            }}>
              {(this.state.msgTab === "Messages") &&
                <div className="events-default-view">
                  <EventMessageView {...this.props} label="Chat" eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} />
                </div>
              }

              {(this.state.msgTab === "Team") &&
                <div className="events-default-view">
                  <EventMessageView {...this.props} isTeam={true} isParent={false} label="Group" eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} />
                </div>
              }

              {(this.state.msgTab === "Groups") &&
                <div className="events-default-view">
                  <EventMessageView {...this.props} isTeam={false} isParent={false} label="Group" eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} />
                </div>
              }
              {(this.state.msgTab === "Emails") &&
                <div className="events-default-view">
                  <EventMessageView {...this.props} label="Email" eventToType={this.props.eventToType} eventToID={this.props.eventToID} events={this.props.events} />
                </div>
              }
            </EventViewSplitPane>
          }
        </div>
        <EventMessageModal eventToType={this.props.eventToType} eventToID={this.props.eventToID} sendTo={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo") : {}} value={(FakeData.getData("eventMailTo")) ? FakeData.getData("eventMailTo").email : ""} isOpen={this.state.isEmailing} onClose={() => {
          this.setState({
            isEmailing: false
          });
        }} />
      </div>
    );
  }
}

export class EventMessageView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      isCreatingChat: false,
      isCreatingGroup: false,
      isCreatingEmail: false,
      data: [],
      rawData: [],
      current: null,
      currentId: null,
      users: [],
      isEdittingGroup: false,
      groupEdit: null
    }
  }

  componentDidMount() {
    this.id = "EventMessageView" + this.props.label.toLowerCase();
    FakeData.mountState(this.id, true);
    this._isMounted = true;
    this.getData();
  }

  componentWillUnmount() {
    FakeData.mountState(this.id, false)
    this._isMounted = false;
  }

  onMessageAdd(msg) {
    if (msg === null) {
      return
    }
    this.state.data.push(msg)
    this.setState({
      data: this.state.data
    });
  }

  onGroupAdd(data) {
    if (data === null) {
      return
    }
    this.state.data.push(data)
    this.setState({
      data: this.state.data
    });
  }

  getData() {
    const _that = this
    let url;
    let dataTo;
    if (!this._isMounted) {
      return;
    }
    const { isTeam, isParent } = this.props;
    if (this.props.label === "Group") {
      dataTo = {
        user: FakeData.getData("yoo"),
        toId: this.props.eventToID,
        isSingle: (this.props.eventToType === "T") ? true : false,
        type: this.props.eventToType,
        label: isTeam ? "team" : isParent ? "parent" : "normal"
      }

      url = "/getEventGroups.php?auth0";
    } else if (this.props.label === "Email") {
      dataTo = {
        user: FakeData.getData("yoo"),
        profileId: this.props.eventToID,
        profileType: this.props.eventToType
      }

      url = "/getEmailList.php?auth0";
    } else {
      dataTo = {
        user: FakeData.getData("yoo"),
        profileId: this.props.eventToID,
        profileType: this.props.eventToType
      }

      url = "/getEventMsgs.php?auth0";
    }

    FakeData.post(url, dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return;
        }
        _that.setState({
          rawData: res
        });

        if (_that.state.current !== null) {
          _that.getCurrent(_that.state.currentId)
        }

        _that.onSearchQuery(_that.state.value)
        ///console.log(res);
        _that.getDataID = setTimeout(() => {
          _that.getData()
        }, 1500)
      }),
      error: ((err) => {

      })
    });
  }

  onGroupMessageAdd(id, data) {
    this.state.data.forEach((item, i) => {
      if (item.id === id) {
        item.conversation = data
        this.setState({
          current: data,
          users: item.members
        });
      }
    })
  }

  getCurrent(id) {
    if (this.props.label === "Email") {
      return;
    }
    this.state.data.forEach((item, i) => {
      if (item.id === id) {
        this.setState({
          current: (this.props.label !== "Chat") ? item.conversation : item,
          users: (this.props.label !== "Chat") ? item.members : []
        });
      }
    })
  }

  onSearchQuery(val) {
    if (this.props.label === "Email") {
      const arr = []
      this.state.rawData.forEach((item, i) => {
        if (item.subject.toLowerCase().indexOf(val.toLowerCase()) > -1) {
          arr.push(item)
          this.setState({
            data: arr
          });
        }
      })
    } else if (this.props.label === "Group") {
      const arr = []
      this.state.rawData.forEach((item, i) => {
        if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
          arr.push(item)
          this.setState({
            data: arr
          });
        }
      })
    } else {
      const arr = []
      this.state.rawData.forEach((item, i) => {
        if (item.otherUser.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
          arr.push(item)
          this.setState({
            data: arr
          });
        }
      })
    }
  }

  editGroup(item) {
    //console.log(item);
    this.setState({
      isEdittingGroup: true,
      groupEdit: item
    });
    return;
  }

  spreadTeamNames = (teams = []) => {
    const _teams = [];
    teams.forEach((item) => {
      _teams.push(item.name);
    });

    return _teams.join(", ");
  }

  render() {
    const { isTeam, isParent } = this.props;
    if (this.props.label !== "Email") {
      this.state.data.sort(function (a, b) {
        if (a.last_msg === null || b.last_msg === null) {
          return b.name - b.name;
        } else {
          return b.last_msg.timestamp - a.last_msg.timestamp;
        }
      })
    }

    return (
      <div className="event-msg-view">
        <div className="event-msg-view-list">
          <button onClick={() => {
            if (this.props.label === "Chat") {
              this.setState({
                isCreatingChat: true
              });
            } else if (this.props.label === "Email") {
              this.setState({
                isCreatingEmail: true
              });
            } else {
              this.setState({
                isCreatingGroup: true
              });
            }
          }}>+ New {isTeam || isParent ? "Chat" : this.props.label}</button>
          <div className="event-msg-view-list-search">
            <input value={this.state.value} placeholder="Search..." onChange={(e) => {
              this.setState({
                value: e.target.value
              });

              this.onSearchQuery(e.target.value)
            }} />
            <i className="material-icons">search</i>
          </div>
          {this.props.label === "Email" &&
            <div className="event-msg-view-mail-list">
              {
                this.state.data.map((item, i) => {
                  return (
                    <div className="event-msg-view-mail-list-item" key={i} onClick={() => {
                      this.setState({
                        current: item,
                        currentId: item.id
                      });
                    }}>
                      <span>{item.subject.charAt(0)}</span>
                      <span>{item.subject}</span>
                      <span>{window.moment(item.date).calendar()}</span>
                      <span className="player_event_delete"></span>
                    </div>
                  )
                })
              }
            </div>
          }
          {this.state.data.length === 0 &&
            <span style={{ display: "block", lineHeight: "30px", textAlign: "center" }}>No Records</span>
          }
          {(this.props.label !== "Email" && this.state.data.length > 0) &&
            <div className="event-msg-view-list-items">
              {
                this.state.data.map((item, i) => {
                  if (!item) {
                    return;
                  }
                  return (
                    <div key={i} className="event-msg-view-list-item" onClick={() => {
                      if (this.props.label === "Chat") {
                        this.setState({
                          current: item,
                          currentId: item.id
                        });
                      } else {
                        this.setState({
                          current: item.conversation,
                          currentId: item.id,
                          users: item.members
                        });
                      }
                    }}>
                      {this.props.label === "Chat" &&
                        <img src={item.otherUser.image} />
                      }
                      {item &&
                        <div className="event-msg-view-list-item-content">
                          {this.props.label !== "Chat" && <span><strong>{item.name}</strong> {(item.profile && item.profile.teams.length > 0 ? " (" + this.spreadTeamNames(item.profile.teams).substring(0, 50) + "..)" : "")}</span>}
                          {this.props.label === "Chat" && <span>{FakeData.nullify(item.otherUser.name)}</span>}
                          <span>{item.last_msg === null ? "" : ((item.last_msg.isYou) ? item.last_msg.body : item.last_msg.user.name + " : " + item.last_msg.body)}</span>

                        </div>
                      }
                      {item && item.unread > 0 &&
                        <div className="event-msg-view-list-item-read">
                          {item.unread}
                        </div>
                      }
                      {this.props.label === "Group" &&
                        <i className="material-icons" onClick={() => this.editGroup(item)}>settings</i>
                      }
                    </div>
                  )
                })
              }
            </div>
          }
        </div>
        {(this.state.current === null && this.props.label === "Chat") &&
          <div className="event-msg-view-chat no-preview">
            <h3>Select A Chat To Preview</h3>
          </div>
        }
        {(this.state.current === null && this.props.label === "Email") &&
          <div className="event-msg-view-chat no-preview">
            <h3>Select Mail To Preview</h3>
          </div>
        }
        {(this.state.current !== null && this.props.label === "Email") &&
          <div className="event-msg-view-chat">
            <div className="event-msg-view-chat-header">
              <span>{this.state.current.subject}</span>
            </div>
            <div className="event-msg-view-eamil-msg" dangerouslySetInnerHTML={{ __html: this.state.current.message }}>

            </div>
          </div>
        }
        {(this.state.current === null && this.props.label === "Group") &&
          <div className="event-msg-view-chat no-preview">
            <h3>{(this.state.currentId !== null) ? "No Conversation For The Selected Group" : "Select A Chat To Preview"}</h3>
            {this.state.currentId !== null &&
              <button className="button" onClick={() => {
                this.setState({
                  isCreatingChat: true
                });
              }}>Start A Conversation</button>
            }
          </div>
        }
        {(this.state.current !== null && this.props.label !== "Email") &&
          <EventChatView eventToType={this.props.eventToType} eventToID={this.props.eventToID} type={this.props.label} users={(this.props.label === "Chat") ? null : this.state.users} message={this.state.current} />
        }
        {this.props.label === "Chat" &&
          <EventNewChatView teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isCreatingChat} onClose={(data) => {
            this.setState({
              isCreatingChat: false
            });
            this.onMessageAdd(data)
          }} />
        }

        {this.props.label === "Group" &&
          <EventNewChatView teams={this.props.teams} forGroup="true" toId={this.props.eventToID} users={this.state.users} eventToType="EG" eventToID={this.state.currentId} isOpen={this.state.isCreatingChat} onClose={(data) => {
            this.setState({
              isCreatingChat: false
            });
            this.onGroupMessageAdd(this.state.currentId, data)
          }} />
        }

        {this.is &&
          <EventGroupChatCreate teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isCreatingGroup} onClose={(data) => {
            this.setState({
              isCreatingGroup: false
            });
            this.onGroupAdd(data)
          }} />
        }

        {this.state.isCreatingGroup &&
          <CreateMessasingGroup isCoachView={true} isParent={isParent} isTeam={isTeam} isSelective={isParent || isTeam ? true : false} teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isCreatingGroup} type={"normal"} onClose={(group) => {
            if (group === null) {
              this.setState({ isCreatingGroup: false });
            } else {
              this.setState({ isCreatingGroup: false });
              this.onGroupAdd(group)
            }
          }} />
        }

        {this.state.isCreatingEmail &&
          <CreateMessasingModal isCoachView={true} isParent={isParent} isTeam={isTeam} isSelective={isParent || isTeam ? true : false} teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isCreatingEmail} type={"normal"} onClose={(group) => {
            if (group === null) {
              this.setState({ isCreatingEmail: false });
            } else {
              this.setState({ isCreatingEmail: false });
              //this.onGroupAdd(group)
            }
          }} />
        }

        {this.state.groupEdit !== null &&
          <EventGroupChatCreate teams={this.props.teams} isEdit="true" data={this.state.groupEdit} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isEdittingGroup} onClose={(data) => {
            this.setState({
              isEdittingGroup: false,
              groupEdit: null
            });
            this.onGroupAdd(data)
          }} />
        }
      </div>
    );
  }
}

class EventChatView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: this.props.message,
      msg: {
        body: "",
        media: {}
      },
      isEmailing: false
    }
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    const current = this.state.message
    const next = nextProps.message
    if (next.id !== current.id) {
      this.setState({
        message: next
      });
    } else {
      if (next.messages.length > current.messages.length) {
        this.setState({
          message: next
        });
      }
    }
  }

  onSend(cb) {
    const _that = this
    const dataTo = {
      userFrom: FakeData.getData("yoo").id,
      userTo: this.state.message.otherUser.id,
      msg: this.state.msg,
      id: this.state.message.id,
      isGroup: (this.props.type !== "Chat") ? true : false,
      users: this.props.users
    }

    if (this.state.msg.body === "" && !this.state.msg.media.id) {
      this.setState({
        msgError: true
      });
      return;
    }

    //console.log(dataTo);
    FakeData.post("/replyToChat.php?auth0", dataTo, {
      success: ((res) => {
        _that.state.message.messages.unshift(res)
        _that.setState({
          message: _that.state.message,
          msg: {
            body: "",
            media: {}
          }
        });
        //cb.apply(_that)
        cb.apply(this)
        //console.log(res);
      }),
      error: ((err) => {

      })
    })
    //cb.apply(this)
  }

  spreadTeamNames = (teams = []) => {
    const _teams = [];
    teams.forEach((item) => {
      _teams.push(item.name);
    });

    return _teams.join(", ");
  }

  render() {
    return (
      <div className="event-msg-view-chat">
        <div className="event-msg-view-chat-header">
          {this.state.message.otherUser.image !== null &&
            <img src={this.state.message.otherUser.image} />
          }
          {this.state.message.profile && <span><strong>{this.state.message.otherUser.name}</strong> {(this.state.message.profile && this.state.message.profile.teams.length > 0 ? " (" + this.spreadTeamNames(this.state.message.profile.teams).substring(0, 80) + "..)" : "")}</span>}
          {!this.state.message.profile && <span>{this.state.message.otherUser.name}</span>}
          {this.props.type === "Chat" &&
            <i className="material-icons" onClick={() => {
              const _that = this
              FakeData.setData("eventMailTo", this.state.message.otherUser);
              setTimeout(() => {
                _that.setState({
                  isEmailing: true
                });
              }, 1000)
            }}>mail</i>
          }
          {this.props.type !== "Chat" &&
            <i className="material-icons" onClick={() => {
              const _that = this
              FakeData.setData("eventMailTo", this.state.message.otherUser);
              setTimeout(() => {
                _that.setState({
                  isEmailing: true
                });
              }, 1000)
            }}>mail</i>
          }
          <i className="material-icons">delete</i>
        </div>
        <div className="event-msg-view-chat-msgs">
          {
            this.state.message.messages.map((item, i) => {
              return (
                <EventChatViewIem data={item} key={i} />
              )
            })
          }
        </div>

        <ChatTextBox error={this.state.msgError} onBodyChange={(text) => {
          //console.log(text);
          this.state.msg.body = text
          this.setState({
            msg: this.state.msg,
            msgError: false
          });
        }} onFileChange={(file) => {
          this.state.msg.media = file
          this.setState({
            msg: this.state.msg,
            msgError: false
          });
        }} onEnter={(cb) => {
          this.onSend(cb)
        }} sendOnEnter="true" />
        {this.props.type === "Chat" &&
          <CreateMessasingModal isCoachView={true} withTopic={true} topic={"General"} withUsers={true} users={[this.state.message.otherUser]} teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isEmailing} type={"normal"} onClose={(group) => {
            if (group === null) {
              this.setState({ isEmailing: false });
            } else {
              this.setState({ isEmailing: false });
              //this.onGroupAdd(group)
            }
          }} />
        }
        {this.props.type === "Group" &&
          <CreateMessasingModal isCoachView={true} withTopic={true} topic={this.state.message.name} withUsers={true} users={this.props.users} teams={this.props.teams} eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isEmailing} type={"normal"} onClose={(group) => {
            if (group === null) {
              this.setState({ isEmailing: false });
            } else {
              this.setState({ isEmailing: false });
              //this.onGroupAdd(group)
            }
          }} />
        }
      </div>
    );
  }
}

class EventChatViewIem extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={(this.props.data.isYou) ? "event-msg-view-chat-msg you" : "event-msg-view-chat-msg"}>
        {this.props.data.media !== null &&
          <MediaItem file={this.props.data.media} />
        }
        <span className="msg">{this.props.data.body}</span>
        <span>{window.moment(this.props.data.date).calendar()}</span>
      </div>
    );
  }
}

class EventNewChatView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      team: null,
      player: null,
      msg: {
        body: "",
        media: {}
      },
      //isTeam: (this.props.eventToType === "T") ? true : false
    }
  }

  componentDidMount() {
    const teams = FakeData.getData("yoo").ownTeams
    teams.forEach((item, i) => {
      if (item.id === this.props.eventToID) {
        this.setState({
          team: item
        });
      }
    })
  }

  startChat() {
    const _that = this
    if (this.state.msg.body === "" && !this.state.msg.media.id) {
      this.setState({
        msgError: true
      });
      return;
    }

    const dataTo = {
      userFrom: FakeData.getData("yoo").id,
      userTo: this.state.player.userId,
      type: "event",
      msg: this.state.msg,
      profileId: this.props.eventToID,
      profileType: this.props.eventToType
    }

    FakeData.post("/startNewChat.php?auth0", dataTo, {
      success: ((res) => {
        if (res.error) {
          alert("Conversation Already Exists!!")
          return
        }
        this.setState({
          team: null,
          player: null,
          msg: {
            body: "",
            media: {}
          }
        });
        this.props.onClose(res)
      }),
      error: ((err) => {

      })
    }, true, "", () => { })
  }

  startGroupChat() {
    const _that = this
    if (this.state.msg.body === "" && !this.state.msg.media.id) {
      this.setState({
        msgError: true
      });
      return;
    }

    const dataTo = {
      userFrom: FakeData.getData("yoo").id,
      toMembers: this.props.users,
      userTo: this.props.toId,
      type: "event",
      msg: this.state.msg,
      profileId: this.props.eventToID,
      profileType: "EG"
    }

    //console.log(dataTo);

    FakeData.post("/startNewChat.php?auth0", dataTo, {
      success: ((res) => {
        if (res.error) {
          alert("Conversation Already Exists!!")
          return
        }
        this.setState({
          team: null,
          player: null,
          msg: {
            body: "",
            media: {}
          }
        });
        this.props.onClose(res)
      }),
      error: ((err) => {

      })
    }, true, "", () => { })
  }

  render() {
    const teams = FakeData.getData("yoo").ownTeams
    if (this.props.forGroup) {
      return (
        <Modal isOpen={this.props.isOpen} onClose={() => {
          this.setState({
            team: null,
            player: null,
            msg: {
              body: "",
              media: {}
            }
          });
          this.props.onClose(null)
        }}>
          <div className="add-place">
            <h1>Add Chat</h1>
            <ChatTextBox error={this.state.msgError} onBodyChange={(text) => {
              //console.log(text);
              this.state.msg.body = text
              this.setState({
                msg: this.state.msg,
                msgError: false
              });
            }} onFileChange={(file) => {
              this.state.msg.media = file
              this.setState({
                msg: this.state.msg,
                msgError: false
              });
            }} />
            <button className="gbl-btn" onClick={() => {
              this.startGroupChat()
            }}>Send</button>
          </div>
        </Modal>
      )
    }
    return (
      <Modal isOpen={this.props.isOpen} onClose={() => {
        this.setState({
          team: null,
          player: null,
          msg: {
            body: "",
            media: {}
          }
        });
        this.props.onClose(null)
      }}>
        <div className="add-place">
          <h1>Add Chat</h1>
          {!this.state.isTeam &&
            <div className="input-field">
              <span>Select A Team</span>
              <ComboBox data={this.props.teams} placeholder="Select a team..." onSelectedItem={(item) => {
                this.setState({
                  team: item
                });
                //console.log(item);
              }} />
            </div>
          }
          {this.state.team === null &&
            <div style={{ textAlign: "center", color: "#aaa" }}>
              Please Select A Team
            </div>
          }

          {(this.state.team !== null && this.state.team.players.length === 0) &&
            <div style={{ textAlign: "center", color: "#aaa" }}>
              No Players Found
            </div>
          }

          {(this.state.team !== null && this.state.team.players.length > 0) &&
            <div className="input-field">
              <span>Select A Player</span>
              <ComboBox data={this.state.team.players} placeholder="Select a player..." onSelectedItem={(item) => {
                this.setState({
                  player: item
                });
                //console.log(item);
              }} />
            </div>
          }
          {this.state.player !== null &&
            <ChatTextBox onBodyChange={(text) => {
              //console.log(text);
              this.state.msg.body = text
              this.setState({
                msg: this.state.msg
              });
            }} onFileChange={(file) => {
              this.state.msg.media = file
              this.setState({
                msg: this.state.msg
              });
            }} />
          }
          {this.state.player !== null &&
            <button className="gbl-btn" onClick={() => {
              this.startChat()
            }}>Start Chat</button>
          }
        </div>
      </Modal>
    );
  }
}

export class EventGroupChatCreate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      team: null,
      players: [],
      playersData: [],
      groupName: (this.props.isEdit) ? this.props.data.name : "",
      nameError: false,
      //isTeam: (this.props.eventToType === "T") ? true : false,
      olderPlayers: (this.props.isEdit) ? this.props.data.members : [],
      playerToDelete: null,
      isDeleting: false,
      type: ""
    }
  }

  componentDidMount() {
    const teams = FakeData.getData("yoo").ownTeams
    teams.forEach((item, i) => {
      if (item.id === this.props.eventToID) {
        this.setState({
          team: item
        });

        this.getPlayers([item])
      }
    })
  }

  onClose() {
    this.setState({
      team: null,
      players: [],
      playersData: [],
      groupName: (this.props.isEdit) ? this.props.data.name : "",
      nameError: false,
      type: ""
    });
    this.props.onClose(null)
  }

  getPlayers(teams) {
    const newArr = []
    teams.forEach((item, i) => {
      item.players.forEach((p, x) => {
        const inArray = (newArr.indexOf(p) > -1) ? true : false
        if (!inArray) {
          newArr.push(p)
          this.setState({
            playersData: newArr
          });
        }
      })
    })
  }

  createGroup() {
    if (this.state.groupName === "") {
      this.setState({
        nameError: true
      });
      return
    }

    if (this.state.type === "") {
      this.setState({
        typeError: true
      });
      return
    }

    if (this.state.team === null && !this.props.isEdit) {
      this.setState({
        teamError: true
      });
      return
    }

    if (this.state.players.length === 0 && this.state.olderPlayers.length === 0) {
      this.setState({
        playersError: true
      });
      return
    }

    const _that = this
    const dataTo = {
      name: this.state.groupName,
      id: (this.props.isEdit) ? this.props.data.id : 0,
      players: this.state.players,
      team: (this.props.isEdit) ? this.props.data.team : this.state.team,
      userFrom: FakeData.getData("yoo").id,
      type: this.state.type.toLowerCase()
    }

    FakeData.post((this.props.isEdit) ? "/editGroup.php?auth0" : "/createGroup.php?auth0", dataTo, {
      success: ((res) => {
        if (this.props.isEdit) {
          //console.log(res);
          this.props.onClose(null)
          return
        }
        this.setState({
          team: null,
          players: [],
          playersData: [],
          groupName: "",
          nameError: false,
          type: ""
        });
        this.props.onClose(res)
        FakeData.alert("Group was created!")
      }),
      error: ((err) => {

      })
    }, true, "", (d) => { })
  }

  removeMember(item) {
    const _that = this
    const dataTo = {
      groupId: this.props.data.id,
      memberId: item.id
    }

    FakeData.post("/removeGroupMember.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeGroupMember.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove user";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeleting: false,
            playerToDelete: null
          });
          return
        }
        const index = _that.state.olderPlayers.indexOf(item)
        _that.state.olderPlayers.splice(index, 1)
        _that.setState({
          olderPlayers: _that.state.olderPlayers,
          isDeleting: false,
          playerToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "User removed!", ((res) => {

    }))
  }

  render() {
    const teams = this.props.teams;
    return (
      <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
        <div className="add-place">
          <h1>{(this.props.isEdit) ? "Edit " + this.props.data.name : "Add Group"}</h1>
          <div className={(this.state.nameError) ? "input-field error" : "input-field"}>
            <span>Group Name</span>
            <input value={this.state.groupName} style={{ padding: "4px" }} onChange={(e) => {
              this.setState({
                nameError: false,
                groupName: e.target.value
              });
            }} />
          </div>
          <div className={(this.state.typeError) ? "input-field error" : "input-field"}>
            <span>Select Group Type</span>
            <ComboBox data={(FakeData.getData("yoo").ownTeams.length === 0) ? ["Social"] : ['Social', 'Training', 'Game', 'Team']} placeholder="Select Group Type" onSelectedItem={(item) => {
              this.setState({
                type: item,
                typeError: false
              });
            }} />
          </div>
          {!this.state.isTeam &&
            <div className={(this.state.teamError) ? "input-field error" : "input-field"}>
              <span>Select A Team</span>
              <ComboBox data={FakeData.listify(teams)} placeholder="Select A Team" onSelectedItem={(item) => {
                this.setState({
                  team: item,
                  teamError: false
                });
                this.getPlayers([item])
              }} />
            </div>
          }
          <div className={(this.state.playersError) ? "input-field error" : "input-field"} style={{ minHeight: "70px", height: "auto" }}>
            <span>Group Members</span>
            {this.props.isEdit &&
              <TagView withData={this.state.olderPlayers} onItemRemove={(item) => {
                this.setState({
                  isDeleting: true,
                  playerToDelete: item
                });
              }} user={FakeData.getData("yoo")} withTopElem="true" onAddTag={this.onAddTagEdit} isShown="true" />

            }
            {this.state.playersData.length === 0 &&
              <TagView user={FakeData.getData("yoo")} data={FakeData.listify(FakeData.getData("yoo").friends)} withTopElem="true" onAddTag={(d) => {
                this.setState({
                  players: d,
                  playersError: false
                });
              }} isShown="true" />
            }
            {this.state.playersData.length > 0 &&
              <TagView user={FakeData.getData("yoo")} data={this.state.playersData} withTopElem="true" onAddTag={(d) => {
                this.setState({
                  players: d,
                  playersError: false
                });
              }} isShown="true" />
            }
          </div>
          <button className="gbl-btn" onClick={() => {
            this.createGroup()
          }}>Save Group</button>
          <ConfirmModal message="Are you sure you want to remove this member?<br/>" isOpen={this.state.isDeleting} data={this.state.playerToDelete}
            onOkay={(data) => {
              this.removeMember(data)
            }}
            onCancel={() => {
              this.setState({
                isDeleting: false
              })
            }} />
        </div>
      </Modal>
    );
  }
}

export class EventsFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSendingChat: false,
      isEmailing: false,
      isAddingPlayer: false,
      isAddingEvtPlayer: false,
      isAddingEvent: false
    }
  }

  onClose(newPlayer) {
    this.setState({
      isAddingPlayer: false,
      isAddingEvtPlayer: false
    });

    this.props.onPlayerAdd(newPlayer);
  }

  filtDateChanged(e) {
    this.props.onDateSelect(e.target.value)
  }

  render() {
    const _teams = FakeData.listify(this.props.teams);
    //_teams.unshift({ id: null,name:"", players:[], sport:{name:"init"} });
    return (
      <div className="event-filter">
        {this.props.eventToType !== "T" &&
          <div className="filter-box">
            <span>Name</span>
            <ComboBox data={_teams} placeholder="Select a Team..." onSelectedItem={(item) => {
              this.props.onTeamSelect(item)
            }} />
          </div>
        }
        {(!this.props.isCalender && !this.props.canSelectEvent && !this.props.isPlayerView) &&
          <div className="filter-box">
            <span>Event type</span>
            <ComboBox data={["All", "Training", "Social", "Meeting"]} placeholder="Select type..." onSelectedItem={(item) => {
              this.props.onTypeSelect(item);
            }} />
          </div>
        }
        {this.props.canSelectEvent &&
          <div className="filter-box">
            <span>Select event</span>
            <ComboBox data={this.props.events} placeholder="Select event..." onSelectedItem={(item) => {
              this.props.onEventSelect(item);
            }} />
          </div>
        }
        {(!this.props.canSelectEvent && !this.props.isPlayerView) &&
          <div className="filter-box">
            <span>Date</span>
            <input ref={(ref) => FakeData.makeDatePicker(ref, this.filtDateChanged.bind(this))} />
          </div>
        }

        {this.props.isPzlayerView &&
          <div className="player_btn player_message" onClick={() => {
            this.setState({
              isEmailing: true
            });
          }}>Group email</div>
        }

        {this.props.isPzlayerView &&
          <div className="player_btn player_message" onClick={() => {
            this.setState({
              isSendingChat: true
            });
          }}>Group message</div>
        }

        {this.props.isPlayerView &&
          <div className="player_btn player_export">Export</div>
        }

        {(this.props.canAddPlayer && this.props.toEvent) &&
          <div className="evt-drop" onMouseLeave={() => {
            this.setState({
              isAddingEvtPlayer: false
            });
          }}>
            <button onClick={() => {
              this.setState({
                isAddingEvtPlayer: (this.state.isAddingEvtPlayer) ? false : true
              });
            }}>+ Add</button>
            {this.state.isAddingEvtPlayer &&
              <div className="evt-drop-content">
                <a onClick={() => {
                  this.setState({
                    isAddingEvent: true
                  });
                }}>Add Event</a>
                <Link to="/create">Add Competetion</Link>
              </div>
            }
          </div>

        }

        {(this.props.canAddPlayer && !this.props.toEvent) &&
          <button disabled={FakeData.listify(this.props.currentTeam.players).length >= playerLimit[FakeData.nullify(this.props.currentTeam.sport.name).toLowerCase()] ? true : false} onClick={() => {
            this.setState({
              isAddingPlayer: true
            });
          }}>+ Add Player</button>
        }

        {(this.props.canAddRole && !this.props.toEvent) &&
          <button disabled={FakeData.listify(this.props.currentTeam.players).length >= playerLimit[FakeData.nullify(this.props.currentTeam.sport.name).toLowerCase()] ? true : false} onClick={() => {
            this.setState({
              isAddingRole: true
            });
          }}>+ Add Role</button>
        }

        <EventMessageModal eventToType={this.props.eventToType} eventToID={this.props.eventToID} players={this.props.players} value="All Players" isGroup="true" isEmail="true" isOpen={this.state.isEmailing} onClose={() => {
          this.setState({
            isEmailing: false
          });
        }} />

        <EventMessageModal eventToType={this.props.eventToType} eventToID={this.props.eventToID} players={this.props.players} value="All Players" isGroup="true" isEmail="false" isOpen={this.state.isSendingChat} onClose={() => {
          this.setState({
            isSendingChat: false
          });
        }} />
        {this.state.isAddingPlayer &&
          <AddPlayer jerseyArray={[]} sport={FakeData.nullify(this.props.currentTeam.sport.name).toLowerCase()} isOpen={this.state.isAddingPlayer} teamId={this.props.currentTeam.id} squadId={this.props.currentTeam.activeSquad.id} gender={this.props.currentTeam.activeSquad.gender} name={this.props.currentTeam.activeSquad.name} onClose={(player) => this.onClose(player)} />
        }
        <AddEventModal eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={this.state.isAddingEvent} onClose={() => {
          this.setState({
            isAddingEvent: false
          });
        }} />
      </div>
    );
  }
}

class EventHoriList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      offset: {
        start: 0,
        end: 4
      },
      isEditting: false,
      item: null
    }
  }

  render() {
    return (
      <div className="event-hori-list">
        <i className="icon left" onClick={() => {
          const start = this.state.offset.start
          const end = this.state.offset.end
          if (start === 0) {
            return
          }
          this.state.offset.start = start - 1
          this.state.offset.end = end - 1
          this.setState({
            offset: this.state.offset
          });
        }}></i>
        <div className="hori-events">
          {
            this.props.events.map((item, i) => {
              if ((i < this.state.offset.start) || (i > this.state.offset.end)) {
                return null;
              }
              return (
                <div key={i} className={(this.props.data.id === item.id) ? "hori-event active" : "hori-event"} onClick={() => this.props.onEventSelect(item)}>
                  <span>{item.name}</span>
                  <span>{item.date}</span>
                  {!this.props.data.isGame &&
                    <div className="hori-event-indicators">
                      <span>+11</span>
                      <span>+11</span>
                    </div>
                  }
                  {!this.props.data.isGame &&
                    <button onClick={() => {
                      this.setState({
                        isEditting: true,
                        item: item
                      });
                    }}>Edit</button>
                  }
                </div>
              )
            })
          }
        </div>
        <i className="icon right" onClick={() => {
          const end = this.state.offset.end
          const start = this.state.offset.start
          if (end === this.props.events.length) {
            return
          }
          this.state.offset.end = end + 1
          this.state.offset.start = start + 1
          this.setState({
            offset: this.state.offset
          });
        }}></i>
        {this.state.item !== null &&
          <EditEventModal eventToType={this.props.eventToType} eventToID={this.props.eventToID} isOpen={(this.state.isEditting && this.state.item !== null) ? true : false} event={this.state.item} onClose={() => {
            this.setState({
              isEditting: false,
              item: null
            });
          }} />
        }
      </div>
    );
  }
}

class EventInviteList extends Component {
  constructor(props) {
    super(props)
  }

  getInvitesOf(eUser, index) {
    const array = []
    for (let i = index; i < (index + 5); i++) {
      if (this.props.events[i]) {
        const evt = this.props.events[i]
        evt.invites.forEach((item, i) => {
          if (item.user.id === eUser.user.id) {
            array.push(item)
          } else {
            array.push({ error: true })
          }
        })
      } else {

        continue
      }

    }
    return array;
  }

  render() {
    if (this.props.data === null || this.props.data.isGame) {
      return null
    }
    const items = this.props.data.invites
    const index = this.props.events.indexOf(this.props.data)
    return (
      <div className="event-invite-list">
        {
          items.map((item, i) => {
            return (
              <div className="event-invite-list-item" key={i}>
                <span>{item.user.name}</span>
                <div className="invite-log">
                  {
                    this.getInvitesOf(item, index).map((data, x) => {
                      return (
                        <div key={x} className="invite-log-item">
                          {!data.error &&
                            <img src={(data.status === "yes") ? "images/mark_yes.svg" : "images/mark_no.svg"} />
                          }
                          {data.error &&
                            <img />
                          }
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    );
  }
}

export class EventViewSplitPane extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: ""
    }
  }

  setTab(item) {
    this.props.setView(item)
  }

  render() {
    return (
      <div className="event-view-pane">
        <div className="event-view-pane-tabs" style={{ width: ((this.props.isExtended) ? "25%" : "16%") }}>
          {
            this.props.items.map((item, i) => {
              return (
                <div key={i} className={(this.props.active === item) ? "event-view-pane-tab active" : "event-view-pane-tab"} onClick={() => this.props.setView(item)}>{(this.props.hasSuffix) ? item + " " + this.props.suffix : item}</div>
              )
            })
          }
          {(this.props.extraContent) ? this.props.extraContent : ""}
        </div>
        <div className="event-view-pane-view">
          {
            this.props.children
          }
        </div>
      </div>
    );
  }
}

export class EventViewCreateForm1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      event: (this.props.isEditting) ? this.props.event : { name: "", desc: "", type: this.props.eventToType === "T" ? "Training" : "Social", team: { name: "" }, managers: [], id: 0, place: "", invites: [] },
      audienceKey: "P",
      isTaggingAudience: false,
      isEditting: false,
      isDeleting: false,
      itemToDelete: null,
      isAdminDeleting: false,
      adminToDelete: null
    }

    this.onAddTag = this.onAddTag.bind(this)
    this.onAddTagEdit = this.onAddTagEdit.bind(this)
    this.setPlace = this.setPlace.bind(this)

    //console.log(this.props.event);
  }

  componentDidMount() {
    this.state.event['newManagers'] = []
    this.state.event['newInvites'] = []
    this.state.event['type'] = this.props.type ? this.props.type : this.props.eventToType === "T" ? "Training" : "Social"
    this.setState({
      event: this.state.event,
      evtManagerError: false
    });
  }

  onAddTag(tags) {
    this.state.event.managers = tags
    this.setState({
      event: this.state.event,
      evtManagerError: false
    });
  }

  onAddTagEdit(tags) {
    const managers = this.state.event.managers
    const newArr = []
    tags.forEach((item, i) => {
      if (managers.indexOf(item) === -1) {
        newArr.push(item)
        this.state.event['newManagers'] = newArr
        this.setState({
          event: this.state.event,
          evtManagerError: false
        });
      }
    })
  }

  setPlace(data) {
    this.state.event['place'] = data.name;
    this.state.event['coord'] = data.coord
    this.setState({
      event: this.state.event,
      evtPlaceError: false
    });
  }

  onClose = (arr = []) => {
    const _users = [];
    arr.forEach((item, i) => {
      if (item.type === "T") {
        if (!this.inTeams(item) && !FakeData.inArray(item, FakeData.listify(this.state.event.invites))) {
          _users.push(item);
        }
      } else if (item.type === "F") {
        if (!this.inUsers(item) && !FakeData.inArray(item, FakeData.listify(this.state.event.invites))) {
          _users.push(item)
        }
      }
    })

    const invites = FakeData.listify(this.state.event.invites);
    _users.forEach((item) => {
      invites.push(item)
    })

    this.state.event.invites = invites;

    this.setState({
      audienceKey: "F",
      isTaggingAudience: false,
      event: this.state.event,
      evtInviteError: false
    });
  }

  inUsers = (user) => {
    const invites = FakeData.listify(this.state.event.invites);
    const _list = invites.filter((item, i) => {
      return item.id === user.id && item.type == user.type;
    })

    return _list.length > 0 ? true : false;
  }

  inTeams = (team) => {
    const teams = FakeData.listify(this.state.event.teams);
    const _list = teams.filter((item, i) => {
      return item.id === team.id && item.activeSquad.id == team.activeSquad.id;
    })

    return _list.length > 0 ? true : false;
  }

  onCloseEdit(arr) {
    const invites = this.state.event['invites']
    const newArr = []
    arr.forEach((item, i) => {
      if (invites.indexOf(item) === -1) {
        newArr.push(item)
        this.state.event['newInvites'] = newArr
        this.setState({
          audienceKey: "F",
          isTaggingAudience: false,
          event: this.state.event,
          evtInviteError: false
        });
      }
    })
  }

  removeAdmin(item) {
    const _that = this
    const dataTo = {
      eventId: this.state.event.id,
      adminId: item.id
    }

    FakeData.post("/removeEventAdmin.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEventAdmin.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove user";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeleting: false,
            itemToDelete: null
          });
          return
        }
        const index = _that.state.event.managers.indexOf(item)
        _that.state.event.managers.splice(index, 1)
        _that.setState({
          event: _that.state.event,
          isAdminDeleting: false,
          adminToDelete: null
        });
      }),
      error: ((err) => {

      })
    }, true, "User removed!", ((res) => {

    }))
  }

  removeInvite(item) {
    const _that = this
    const dataTo = {
      eventId: this.state.event.id,
      inviteId: item.user.id
    }

    //console.log(dataTo);
    FakeData.post("/removeEventInvite.php?auth0", dataTo, {
      success: ((res) => {
        if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEventInvite.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not remove user";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeleting: false,
            itemToDelete: null
          });
          return
        }
        const index = _that.state.event.invites.indexOf(item)
        _that.state.event.invites.splice(index, 1)
        _that.setState({
          event: _that.state.event,
          isDeleting: false,
          itemToDelete: null
        });

        if (_that.state.event.invites.length === 0) {
          this.setState({
            isEdittingInvites: false
          });
        }
      }),
      error: ((err) => {

      })
    }, true, "User removed!", ((res) => {

    }))
  }

  setKey(key) {
    this.setState({
      audienceKey: key
    });
  }

  updateEvent() {
    const evt = this.state.event
    const _that = this
    if (!evt.type) {
      this.setState({
        evtTypeError: true
      });
      return
    }

    if (evt.team.name === "") {
      this.setState({
        evtTeamError: true
      });

      return
    }

    if (evt.managers.length === 0 && evt.newManagers.length === 0) {
      this.setState({
        evtManagerError: true
      });

      return
    }

    if (!evt.name || evt.name === "") {
      this.setState({
        evtNameError: true
      });

      return
    }

    if (!evt.place || evt.place === "") {
      this.setState({
        evtPlaceError: true
      });

      return
    }

    if (!evt.date || evt.date === "") {
      this.setState({
        evtDateError: true
      });

      return
    }

    if (!evt.startTime || evt.startTime === "") {
      this.setState({
        evtStartTimeError: true
      });

      return
    }

    let date = new Date(evt.date + " " + evt.startTime + ":00");
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    evt['fullStartTimestamp'] = date.toUTCString()

    if (!evt.endTime || evt.endTime === "") {
      this.setState({
        evtEndTimeError: true
      });

      return
    }

    date = new Date(evt.date + " " + evt.endTime + ":00");
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    evt['fullEndTimestamp'] = date.toUTCString()

    const dataTo = {
      userTo: {
        id: this.props.eventToID,
        type: this.props.eventToType
      },
      event: evt
    }

    FakeData.post("/updateEvent.php?auth0", dataTo, {
      success: ((res) => {
        if (res.status) {
          this.props.onAfterAdd()
        } else if (!res.status) {
          var el = document.createElement("div");
          var id = FakeData.makeid("/removeEventInvite.php?auth0".length);
          el.className = "snack-bar " + id;
          var sbText = document.createElement("span");
          sbText.className = "sb-text";
          el.appendChild(sbText);

          var sbAction = document.createElement("span");
          sbAction.className = "sb-action";
          el.appendChild(sbAction);
          sbText.textContent = "Could not update event";
          sbAction.textContent = "OK";
          FakeData.setSnack(id, el)
          _that.setState({
            isDeleting: false,
            itemToDelete: null
          });
          this.props.onAfterAdd()
          return
        }
      }),
      error: ((err) => {

      })
    }, true, "", (e) => { })
  }

  save() {
    const evt = this.state.event
    const _that = this
    if (!evt.type || evt === "") {
      this.setState({
        evtTypeError: true
      });
      return
    }

    if (evt.team.name === "") {
      this.setState({
        evtTeamError: true
      });

      return
    }

    if (evt.managers.length === 0) {
      this.setState({
        evtManagerError: true
      });

      return
    }

    if (!evt.name || evt.name === "") {
      this.setState({
        evtNameError: true
      });

      return
    }

    if (!evt.place || evt.place === "") {
      this.setState({
        evtPlaceError: true
      });

      return
    }

    if (!evt.date || evt.date === "") {
      this.setState({
        evtDateError: true
      });

      return
    }


    if (!evt.startTime || evt.startTime === "") {
      this.setState({
        evtStartTimeError: true
      });

      return
    }

    let date = new Date(evt.date + " " + evt.startTime + ":00");
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    evt['fullStartTimestamp'] = date.toUTCString()

    if (!evt.endTime || evt.endTime === "") {
      this.setState({
        evtEndTimeError: true
      });

      return
    }

    date = new Date(evt.date + " " + evt.endTime + ":00");
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    evt['fullEndTimestamp'] = date.toUTCString()

    const dataTo = {
      user: {
        id: FakeData.getData("yoo").id,
        type: "F"
      },
      userTo: {
        id: this.props.eventToID,
        type: this.props.eventToType
      },
      event: evt
    }

    FakeData.post("/createOnceOffEvent.php?auth0", dataTo, {
      success: ((res) => {
        this.setState({
          event: { name: "", desc: "", type: this.props.eventToType === "T" ? "Training" : "Social", team: { name: "" }, managers: [], id: 0, place: "", invites: [] },
          audienceKey: "P",
          isTaggingAudience: false
        });
        this.props.onAfterAdd()
      }),
      error: ((err) => {

      })
    }, true, "Event Added!", ((res) => {

    }))
  }

  setValues(key, e) {
    console.log(e);
  }

  evtNameChange(e) {
    this.state.event.name = e.target.value
    this.setState({
      event: this.state.event,
      evtNameError: false
    });
  }

  evtDateChgange(e) {
    this.state.event.date = e.target.value
    console.log(e.target.value);
    this.setState({
      event: this.state.event,
      evtDateError: false
    });
  }

  evtStartTimeChange(e) {
    this.state.event.startTime = e.target.value
    this.setState({
      event: this.state.event,
      evtStartTimeError: false
    });
  }

  evtEndTimeChange(e) {
    this.state.event.endTime = e.target.value
    this.setState({
      event: this.state.event,
      evtEndTimeError: false
    });
  }

  setInvites = (teams = []) => {
    const _p = [];
    const invites = FakeData.listify(this.state.event.invites);
    teams.forEach((item, i) => {
      const parents = FakeData.listify(item.players);
      if (parents.length > 0) {
        parents.forEach((p, _i) => {
          if (!FakeData.inArray(p.user, invites)) {
            //p.teamId = item.id;
            invites.push(p.user)
          }
        })
      }
    });

    this.state.event.invites = invites;
    this.setState({ event: this.state.event, evtInviteError: false });
  }

  render() {
    return (
      <div className="event-create-form" style={{ padding: "10px 0px" }}>
        <div className="event-create-form-col">
          {!this.props.type &&
            <div className={(this.state.evtTypeError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Event Type</span>
              <ComboBox data={this.props.eventToType !== "T" ? ["Social", "Meeting"] : ["Training", "Social", "Meeting"]} placeholder={(this.props.isEditting) ? this.state.event.type : (this.props.type) ? this.props.type : "Select..."} onSelectedItem={(item) => {
                this.state.event.type = item
                this.setState({
                  event: this.state.event,
                  evtTypeError: false
                });
              }} />
            </div>
          }
          <div className={(this.state.evtTeamError) ? "event-create-form-input error" : "event-create-form-input"}>
            <span>Select a team</span>
            <TeamPicker value={this.state.event.team.name} isMulti={true} onTeamSelect={(teams = []) => {
              this.state.event.team = teams[0];
              this.state.event.teams = teams;
              this.setInvites(teams)
              this.setState({
                event: this.state.event,
                evtTeamError: false
              });
            }} teams={this.props.teams} />
          </div>
          <div className={(this.state.evtManagerError) ? "event-create-form-input error" : "event-create-form-input"}>
            <span>Event Managers</span>
            {!this.props.isEditting &&
              <TagView user={(FakeData.getData("yoo") ? FakeData.getData("yoo") : { friends: [] })} withTopElem="true" onAddTag={this.onAddTag} isShown="true" />
            }
            {this.props.isEditting &&
              <TagView withData={this.state.event.managers} onItemRemove={(item) => {
                this.setState({
                  isAdminDeleting: true,
                  adminToDelete: item
                });
              }} user={(FakeData.getData("yoo") ? FakeData.getData("yoo") : { friends: [] })} withTopElem="true" onAddTag={this.onAddTagEdit} isShown="true" />

            }
            {this.props.isEditting &&
              <TagView user={(FakeData.getData("yoo") ? FakeData.getData("yoo") : { friends: [] })} withTopElem="true" onAddTag={this.onAddTagEdit} isShown="true" />
            }
            <ConfirmModal message={(this.state.event.managers.length === 1) ? "This event only has one admin, if you wish to remove them,<br/> make sure you add a replacement or you wont be able to edit it in the future" : "Are you sure you want to remove this admin?<br/>"} isOpen={this.state.isAdminDeleting} data={this.state.adminToDelete}
              onOkay={(data) => {
                this.removeAdmin(data)
              }}
              onCancel={() => {
                this.setState({
                  isAdminDeleting: false
                })
              }} />
          </div>
          {(this.props.isEditting && this.state.event.invites.length > 0) &&
            <div className="event-create-form-input">
              <span onClick={() => {
                this.setState({
                  isEdittingInvites: true
                });
              }}>People Invited (<i className="material-icons" style={{ fontSize: "11px", color: "#4EA3C9", cursor: "pointer" }}>edit</i>)</span>
              <div className="event-invited-semi-list">
                {
                  this.state.event.invites.map((item, i) => {
                    if (i > 2) {
                      return null
                    } else if ((i + 1) === this.state.event.invites.length && i !== 0) {
                      return (
                        <span key={i}>{item.user.name} (<i style={{ fontSize: "11px", color: "#4EA3C9", cursor: "pointer" }}>...</i>)</span>
                      )
                    } else if (this.state.event.invites.length === 1) {
                      return (
                        <span key={i}>{item.user.name}</span>
                      )
                    } else {
                      return (
                        <span key={i}>{item.user.name}, </span>
                      )
                    }
                  })
                }
              </div>
              <Modal isOpen={this.state.isEdittingInvites} onClose={() => {
                this.setState({
                  isEdittingInvites: false
                });
              }}>
                <div className="add-place">
                  <h1>Edit Invites</h1>
                  <div className="event-invited-edit-list">
                    {
                      this.state.event.invites.map((item, i) => {
                        return (
                          <div className="event-invited-edit-list-item" key={i}>
                            <img src={item.user.image} />
                            <span>{item.user.name}</span>
                            <i className="material-icons" onClick={() => {
                              this.setState({
                                isDeleting: true,
                                itemToDelete: item
                              });
                            }}>delete</i>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </Modal>
              <ConfirmModal message="Are you sure you want to remove this user?<br/>" isOpen={this.state.isDeleting} data={this.state.itemToDelete}
                onOkay={(data) => {
                  //console.log(data);
                  this.removeInvite(data)
                }}
                onCancel={() => {
                  this.setState({
                    isDeleting: false
                  })
                }} />
            </div>
          }
          {this.state.event.type !== "Training" &&
            <div className={(this.state.evtInviteError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Invite People</span>
              <div className="event-invite">
                {this.state.event.type === "Social" &&
                  <div className="event-invite-btn" onClick={() => {
                    this.setState({
                      audienceKey: "F",
                      isTaggingAudience: true
                    });
                  }}>
                    <img src="images/who_sees_friends.svg" />
                    <span>Firends</span>
                  </div>
                }
                <div className="event-invite-btn" onClick={() => {
                  this.setState({
                    audienceKey: "T",
                    isTaggingAudience: true
                  });
                }}>
                  <img src="images/who_sees_team.svg" />
                  <span>Teams</span>
                </div>
                {this.is && <div className="event-invite-btn" onClick={() => {
                  this.setState({
                    audienceKey: "P",
                    isTaggingAudience: true
                  });
                }}>
                  <img src="images/add_circle_drk.svg" />
                  <span>Players</span>
                </div>}

                {!this.props.isEditting && this.state.isTaggingAudience &&
                  <WhoToSeePicker filters={this.state.event.type === "Social" ? ["F", "T"] : ["T"]} team={this.state.event.team} isEvent="true" active={this.state.audienceKey} isOpen={this.state.isTaggingAudience} onClose={(arr) => this.onClose(arr)} />
                }
                {this.props.isEditting && this.state.isTaggingAudience &&
                  <WhoToSeePicker filters={this.state.event.type === "Social" ? ["F", "T"] : ["T"]} team={this.state.event.team} isEvent="true" active={this.state.audienceKey} isOpen={this.state.isTaggingAudience} onClose={(arr) => this.onCloseEdit(arr)} />
                }
              </div>
            </div>
          }
          <div className={(this.state.evtNameError) ? "event-create-form-input error" : "event-create-form-input"}>
            <span>{this.props.type ? this.props.type : "Practice"} Name</span>
            <input value={this.state.event.name} placeholder={this.props.type ? this.props.type + " Name" : "Practice Name"} style={{ width: "100%" }} onChange={this.evtNameChange.bind(this)} />
          </div>
          <div className={(this.state.evtDescError) ? "event-create-form-input error" : "event-create-form-input"}>
            <span>{this.props.type ? this.props.type : "Practice"} Description</span>
            <textarea value={this.state.event.desc} placeholder={this.props.type ? this.props.type + " Description" : "Practice Description"} style={{ width: "100%", resize: "none", minHeight: "50px", height: "152px" }} onChange={(e) => {
              this.state.event.desc = e.target.value
              //console.log(e)
              this.setState({
                event: this.state.event,
                evtDescError: false
              });
            }} />
          </div>
        </div>
        <div className="event-create-form-col" style={{ padding: "0px 10px 0px 20px" }}>
          <div className={(this.state.evtPlaceError) ? "error" : ""}>
            <LocationPicker embed="true" value={(this.props.isEditting) ? this.state.event.place : "Select  a place"} user={FakeData.getData("yoo")} places={(FakeData.getData("yoo") && FakeData.getData("yoo").placesLived) ? FakeData.getData("yoo").placesLived.others : []} onSetPlace={this.setPlace} onChange={() => { }} />
          </div>

          <div className={(this.state.evtDateError) ? "event-create-form-input error" : "event-create-form-input"}>
            <span>Date</span>
            <input value={this.state.event.date} ref={(ref) => FakeData.makeDatePicker(ref, this.evtDateChgange.bind(this))} type="text" style={{ width: "100%" }} onChange={() => { }} />
          </div>
          <div className="split-input">
            <div className={(this.state.evtStartTimeError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Start Time</span>
              <input value={this.state.event.startTime} ref={(ref) => FakeData.makeTimePicker(ref, this.evtStartTimeChange.bind(this))} type="text" style={{ width: "100%" }} onChange={() => { }} />
            </div>
            <div className={(this.state.evtEndTimeError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>End Time</span>
              <input value={this.state.event.endTime} ref={(ref) => FakeData.makeTimePicker(ref, this.evtEndTimeChange.bind(this))} type="text" style={{ width: "100%" }} onChange={() => { }} />
            </div>
          </div>

          {!this.props.isEditting &&
            <button className="create-event-btn" onClick={() => this.save()}>Add Event</button>
          }
          {this.props.isEditting &&
            <button className="create-event-btn" onClick={() => this.updateEvent()}>Update Event</button>
          }
        </div>
      </div>
    );
  }
}

class EventViewCreateForm2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      event: { name: "", desc: "", type: this.props.eventToType === "T" ? "Training" : "Social", team: { name: "", startTime: "", endTime: "", coaches: [] }, managers: [], id: 0, place: "", invites: [] },
      audienceKey: "P",
      isTaggingAudience: false,
      recurringDays: [],
      eventsToPost: [],
      initIndex: 0,
      eventsLength: 0,
      isSending: false
    }

    this.onAddTag = this.onAddTag.bind(this)
  }

  componentDidMount() {
    this.setState({
      recurringDays: this.generateDays()
    });
  }

  evtNameChange(e) {
    this.state.event.name = e.target.value
    this.setState({
      event: this.state.event,
      evtNameError: false
    });
  }

  onAddTag(tags) {
    this.state.event.managers = tags
    this.setState({
      event: this.state.event,
      evtManagerError: false
    });
  }

  onClose = (arr = []) => {
    const _users = [];
    arr.forEach((item, i) => {
      if (item.type === "T") {
        if (!this.inTeams(item) && !FakeData.inArray(item, FakeData.listify(this.state.event.invites))) {
          _users.push(item);
        }
      } else if (item.type === "F") {
        if (!this.inUsers(item) && !FakeData.inArray(item, FakeData.listify(this.state.event.invites))) {
          _users.push(item)
        }
      }
    })

    const invites = FakeData.listify(this.state.event.invites);
    _users.forEach((item) => {
      invites.push(item)
    })

    this.state.event.invites = invites;

    this.setState({
      audienceKey: "F",
      isTaggingAudience: false,
      event: this.state.event,
      evtInviteError: false
    });
  }

  inUsers = (user) => {
    const invites = FakeData.listify(this.state.event.invites);
    const _list = invites.filter((item, i) => {
      return item.id === user.id && item.type == user.type;
    })

    return _list.length > 0 ? true : false;
  }

  inTeams = (team) => {
    const teams = FakeData.listify(this.state.event.teams);
    const _list = teams.filter((item, i) => {
      return item.id === team.id && item.activeSquad.id == team.activeSquad.id;
    })

    return _list.length > 0 ? true : false;
  }

  save() {
    const evt = this.state.event
    const _that = this
    let isError = false
    if (!evt.type) {
      this.setState({
        evtTypeError: true
      });
      return
    }

    if (evt.team.name === "") {
      this.setState({
        evtTeamError: true
      });

      return
    }

    if (evt.managers.length === 0) {
      this.setState({
        evtManagerError: true
      });

      return
    }

    if (evt.invites.length === 0) {
      alert("Invite players");
      this.setState({
        evtInviteError: true
      });

      return
    }

    /*if (!evt.startTime || evt.startTime === "") {
      this.setState({
        evtStartTimeError: true
      });

      return
    }


    if (!evt.endTime || evt.endTime === "") {
      this.setState({
        evtEndTimeError: true
      });

      return
    }*/

    if (!evt.name || evt.name === "") {
      this.setState({
        evtNameError: true
      });

      return
    }

    const _recEvents = [];

    this.state.recurringDays.forEach((item, i) => {
      //console.log(item);
      if ((item.day !== "") && ((item.sTime === "") || (item.eTime === "") || (item.place === "") || (item.coach.id === null))) {
        item.error = true
        isError = true
        this.setState({
          recurringDays: this.state.recurringDays
        });
        return;
      } else if (item.day === "") {

      } else {
        item.error = false
        isError = false;
        _recEvents.push(item);
        this.setState({
          recurringDays: this.state.recurringDays
        });
      }
    })

    if (isError) {
      return
    }

    const _events = [];

    _recEvents.forEach((item, i) => {
      evt.managers.push(item.coach);
      const __event = {
        name: evt.name,
        desc: evt.desc,
        team: evt.team,
        managers: evt.managers,
        place: item.place,
        coord: item.coord,
        invites: evt.invites,
        date: item.day + " " + item.sTime,
        day: item.day,
        type: evt.type,
        startTime: item.sTime,
        endTime: item.eTime,
        fullStartTimestamp: item.day + " " + item.sTime,
        fullEndTimestamp: item.day + " " + item.eTime
      };

      const __event__ = {
        user: {
          id: FakeData.getData("yoo").id,
          type: "F"
        },

        userTo: {
          id: this.props.eventToID,
          type: this.props.eventToType
        },

        event: __event,
      }

      _events.push(__event__);
    })

    console.log(_events);

    if (_events.length === 0) {
      alert("Fill in at least one day event data");
    } else {
      this.setState({ eventsLength: _events.length, initIndex: 0, isSending: true, eventsToPost: _events });
      setTimeout(() => {
        _that.postThis(0)
      }, 1000);
    }

    /*FakeData.post("/createRecurringEvent.php?auth0", dataTo, {
      success: ((res) => {
        console.log(res);
        _that.setState({
          event: { name: "", desc: "", team: { name: "", startTime: "", endTime: "", coaches: [] }, managers: [], id: 0, place: "", invites: [] },
          audienceKey: "P",
          isTaggingAudience: false,
          recurringDays: this.generateDays()
        });

        this.props.onAfterAdd()
      }),
      error: ((err) => {
        console.log(err);
      })
    }, true, "Event Added!", ((res) => {

    }))*/
  }

  postThis = (_event) => {
    const _that = this;
    const isLast = (_event + 1) === this.state.eventsLength ? true : false;
    FakeData.post("/createOnceOffEvent.php?auth0", this.state.eventsToPost[_event], {
      success(res) {
        const next = _event + 1;
        _that.setState({ initIndex: next, isSending: !isLast });
        if (isLast) {
          FakeData.alert("Events were added successfully!");
          _that.setState({
            eventsLength: 0,
            initIndex: 0,
            isSending: false,
            isTaggingAudience: false,
            eventsToPost: [],
            recurringDays: +_that.generateDays(),
            event: { name: "", desc: "", team: { name: "", startTime: "", endTime: "", coaches: [] }, managers: [], id: 0, place: "", invites: [] },
          });

          _that.props.onAfterAdd();
        } else {
          setTimeout(() => {
            _that.postThis(next)
          }, 1500)
        }
      },
      error(err) {

      }
    }, isLast, "", () => { })
  }

  generateDays() {
    const data = []
    for (let i = 0; i < 7; i++) {
      data.push({
        tmpID: FakeData.makeid(i + 7),
        place: "",
        coord: { lat: "", lon: "" },
        sTime: "",
        eTime: "",
        coach: { id: null },
        day: ""
      })
    }

    return data
  }

  evtStartTimeChange(e) {
    this.state.event.startTime = e.target.value
    this.setState({
      event: this.state.event,
      evtStartTimeError: false
    });
  }

  evtEndTimeChange(e) {
    this.state.event.endTime = e.target.value
    this.setState({
      event: this.state.event,
      evtEndTimeError: false
    });
  }

  getDataWidthNames(arr) {
    const array = []
    arr.forEach((item, i) => {
      array.push(item.name)
    })

    return array;
  }

  getCoaches = (_team) => {
    const teams = FakeData.listify(this.state.event.teams);
    const list = [];
    teams.forEach((team) => {
      if (team.activeSquad) {
        const _c = [];
        if (team.activeSquad.coach) {
          list.push(team.activeSquad.coach)
        }

        if (team.activeSquad.assCoach) {
          list.push(team.activeSquad.assCoach)
        }
      }
    })

    return list;
  }

  setInvites = (teams = []) => {
    const _p = [];
    const invites = FakeData.listify(this.state.event.invites);
    teams.forEach((item, i) => {
      const parents = FakeData.listify(item.players);
      if (parents.length > 0) {
        parents.forEach((p, _i) => {
          if (!FakeData.inArray(p.user, invites)) {
            //p.teamId = item.id;
            invites.push(p.user)
          }
        })
      }
    });

    this.state.event.invites = invites;
    this.setState({ event: this.state.event, evtInviteError: false });
  }

  render() {

    if (this.state.isSending) {
      return (
        <div className="event-create-form-container">
          <LoadingState isShown={true} text={"Processing Event " + (this.state.initIndex + 1) + " of " + this.state.eventsLength} />
        </div>
      )
    }
    //const coaches = this.getDataWidthNames(this.state.event.team.coaches)
    return (
      <div className="event-create-form-container">
        <div className="event-create-form">
          <div className="event-create-form-col">
            <div className={(this.state.evtTypeError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Event Type</span>
              <ComboBox data={this.props.eventToType !== "T" ? ["Social", "Meeting"] : ["Training", "Social", "Meeting"]} placeholder="Select..." onSelectedItem={(item) => {
                this.state.event.type = item
                this.setState({
                  event: this.state.event,
                  evtTypeError: false
                });
              }} />
            </div>
            <div className={(this.state.evtTeamError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Select a teams</span>
              <TeamPicker value={this.state.event.team.name} isMulti={true} onTeamSelect={(teams = []) => {
                this.state.event.team = teams[0];
                this.state.event.teams = teams;
                this.setInvites(teams)
                this.setState({
                  event: this.state.event,
                  evtTeamError: false
                });
              }} teams={this.props.teams} />
            </div>
            <div className={(this.state.evtManagerError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Event Managers</span>
              <TagView user={(FakeData.getData("yoo") ? FakeData.getData("yoo") : { friends: [] })} withTopElem="true" onAddTag={this.onAddTag} isShown="true" />
            </div>
          </div>
          <div className="event-create-form-col" style={{ padding: "0px 10px 0px 20px" }}>
            {this.is &&
              <div className="split-input">
                <div className={(this.state.evtStartTimeError) ? "event-create-form-input error" : "event-create-form-input"}>
                  <span>Start Date</span>
                  <input value={this.state.event.startTime} ref={(ref) => FakeData.makeDatePicker(ref, this.evtStartTimeChange.bind(this))} type="text" style={{ width: "100%" }} />
                </div>
                <div className={(this.state.evtEndTimeError) ? "event-create-form-input error" : "event-create-form-input"}>
                  <span>End Date</span>
                  <input value={this.state.event.endTime} ref={(ref) => FakeData.makeDatePicker(ref, this.evtEndTimeChange.bind(this))} type="text" style={{ width: "100%" }} />
                </div>
              </div>
            }
            <div className={(this.state.evtNameError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Event Name</span>
              <input value={this.state.event.name} placeholder="Event Name" style={{ width: "100%" }} onChange={this.evtNameChange.bind(this)} />
            </div>
            <div className={(this.state.evtDescError) ? "event-create-form-input error" : "event-create-form-input"}>
              <span>Event Description</span>
              <textarea value={this.state.event.desc} placeholder="Event Description" style={{ width: "100%", resize: "none", minHeight: "50px" }} onChange={(e) => {
                this.state.event.desc = e.target.value
                //console.log(e)
                this.setState({
                  event: this.state.event,
                  evtDescError: false
                });
              }} />
            </div>
          </div>
        </div>
        <div>
          <div className={(this.props.error) ? "event-day-picker error" : "event-day-picker"}>
            <div className="event-day-picker-day-time">
              <span>Action</span>
              <span>Day</span>
              <span>Start Time</span>
              <span>End Time</span>
            </div>
            <div className="event-day-picker-loc-manager">
              <span>Location</span>
              <span>Coach</span>
            </div>
          </div>
        </div>
        <div>
          {
            this.state.recurringDays.map((day, i) => {
              return (
                <EventDayPicker day={i} error={day.error} coachesData={this.getCoaches(this.state.event.team)} coaches={this.getCoaches(this.state.event.team)} key={day.tmpID} event={this.state.event} data={day} onSet={(data) => {
                  this.state.recurringDays[i] = data
                  this.setState({
                    recurringDays: this.state.recurringDays
                  });
                }} />
              )
            })
          }
        </div>
        <div className="event-create-form">
          <div className="event-create-form-col">
            {this.state.event.type !== "Training" &&
              <div className={(this.state.evtInviteError) ? "event-create-form-input error" : "event-create-form-input"}>
                <span>Invite People</span>
                <div className="event-invite">
                  {this.state.event.type === "Social" &&
                    <div className="event-invite-btn" onClick={() => {
                      this.setState({
                        audienceKey: "F",
                        isTaggingAudience: true
                      });
                    }}>
                      <img src="images/who_sees_friends.svg" />
                      <span>Firends</span>
                    </div>
                  }
                  <div className="event-invite-btn" onClick={() => {
                    this.setState({
                      audienceKey: "T",
                      isTaggingAudience: true
                    });
                  }}>
                    <img src="images/who_sees_team.svg" />
                    <span>Teams</span>
                  </div>
                  {this.is &&
                    <div className="event-invite-btn" onClick={() => {
                      this.setState({
                        audienceKey: "P",
                        isTaggingAudience: true
                      });
                    }}>
                      <img src="images/add_circle_drk.svg" />
                      <span>Players</span>
                    </div>
                  }

                  {this.state.isTaggingAudience && <WhoToSeePicker filters={this.state.event.type === "Social" ? ["F", "T"] : ["T"]} team={this.state.event.team} isEvent="true" active={this.state.audienceKey} isOpen={this.state.isTaggingAudience} onClose={(arr) => this.onClose(arr)} />}
                </div>
              </div>
            }
          </div>
          <div className="event-create-form-col" style={{ padding: "0px 10px 0px 20px" }}>
            <button style={{ marginTop: "22px" }} className="create-event-btn" onClick={() => this.save()}>Add Event</button>
          </div>
        </div>
      </div>
    );
  }
}

class EventDayPicker extends Component {
  constructor(props) {
    super(props)
    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    this.state = {
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      value: days[this.props.day],
      valueToo: "Coach...",
      isShowingDays: false,
      event: this.props.event,
      isShowCoaches: false,
      data: this.props.data
    }

    this.setLocation = this.setLocation.bind(this);
  }

  onDaySelect(day) {
    this.state.data['day'] = day
    this.setState({
      value: day,
      data: this.state.data,
      isShowingDays: false
    });
    this.props.onSet(this.state.data)
  }

  onCoachSelect(item) {
    //const coach = this.getCoach(item,this.props.coachesData)
    this.state.data['coach'] = item;
    this.state.data['day'] = this.state.days[this.props.day];
    this.setState({
      valueToo: item.name,
      data: this.state.data,
      isShowCoaches: false
    });
    this.props.onSet(this.state.data)
  }

  getCoach(key, aData) {
    aData.forEach((item, i) => {
      if (item.name === key) {
        return item
      } else {
        return {}
      }
    })
  }

  evtStartTimeChange(e) {
    this.state.data['sTime'] = e.target.value
    this.state.data['day'] = this.state.days[this.props.day];
    this.setState({
      data: this.state.data
    });
    this.props.onSet(this.state.data)
  }

  evtEndTimeChange(e) {
    this.state.data['eTime'] = e.target.value;
    this.state.data['day'] = this.state.days[this.props.day];
    this.setState({
      data: this.state.data
    });
    this.props.onSet(this.state.data)
  }

  setLocation = (data) => {
    this.state.event['place'] = data.name;
    this.state.event['coord'] = data.coord;
    this.state.data['place'] = data.name;
    this.state.data['coord'] = data.coord;
    this.state.data['day'] = this.state.days[this.props.day];
    this.setState({
      data: this.state.data
    });
    this.props.onSet(this.state.data)
  }

  render() {
    const _that = this;
    return (
      <div className={(this.props.error) ? "event-day-picker error" : "event-day-picker"}>
        <div className="event-day-picker-day-time">
          <button onClick={() => {
            const _dat = {
              tmpID: FakeData.makeid(this.props.day + 7),
              place: "",
              coord: { lat: "", lon: "" },
              sTime: "",
              eTime: "",
              coach: { id: null },
              day: ""
            }

            this.setState({
              data: _dat
            });
            this.props.onSet(_dat)
          }}>
            Clear
          </button>
          <div className="event-day-picker-day combo-box" onMouseLeave={() => {
            this.setState({
              isShowingDays: false
            });
          }}>
            <div className="event-day-picker-day-input box-field" onClick={() => {
              this.setState({
                isShowingDays: (this.state.isShowingDays) ? false : false
              });
            }}>
              <span>{this.state.value}</span>
              <span></span>
            </div>
            <div className="event-day-picker-day-content" style={{ display: (!this.state.isShowingDays) ? "none" : "" }}>
              {
                this.state.days.map((item, i) => {
                  return (<span key={i} onClick={() => this.onDaySelect(item)}>{item}</span>)
                })
              }
            </div>
          </div>
          <input ref={(e) => FakeData.makeTimePicker(e, this.evtStartTimeChange.bind(this))} />
          <input ref={(e) => FakeData.makeTimePicker(e, this.evtEndTimeChange.bind(this))} />
        </div>
        <div className="event-day-picker-loc-manager">
          <LocationPicker value={this.state.data.place} user={FakeData.getData("yoo")} places={(FakeData.getData("yoo") && FakeData.getData("yoo").placesLived) ? FakeData.getData("yoo").placesLived.others : []} onSetPlace={this.setLocation} />

          <div className="event-day-picker-day combo-box" onMouseLeave={() => {
            this.setState({
              isShowCoaches: false
            });
          }}>
            <div className="event-day-picker-day-input box-field" onClick={() => {
              this.setState({
                isShowCoaches: (this.state.isShowCoaches) ? false : true
              });
            }}>
              <span>{this.state.valueToo}</span>
              <span></span>
            </div>
            <div className="event-day-picker-day-content" style={{ display: (!this.state.isShowCoaches) ? "none" : "" }}>
              {this.props.coaches.length > 0 &&
                this.props.coaches.map((item, i) => {
                  return (<span key={i} onClick={() => this.onCoachSelect(item)}>{item.name}</span>)
                })
              }
              {this.props.coaches.length == 0 &&
                <span>No Coaches For The Selected Team</span>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class TeamPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      value: "",
      teamArr: [],
      teams: this.props.teams ? this.props.teams : (FakeData.getData("yoo")) ? FakeData.getData("yoo").ownTeams : [],
      filteredData: this.props.teams ? this.props.teams : (FakeData.getData("yoo")) ? FakeData.getData("yoo").ownTeams : [],
      isAddingNew: false,
      userTo: null,
      userError: false,
      emailTo: "",
      emailError: false,
      teamName: "",
      teamError: false
    }

    this.selectTeam = this.selectTeam.bind(this)
    this.addTeam = this.addTeam.bind(this)
    this.setUserToInvite = this.setUserToInvite.bind(this)
    this.emailChange = this.emailChange.bind(this)
    this.nameChange = this.nameChange.bind(this)
  }

  componentWillMount() {
    const _that = this
    this.getDataID = setInterval((() => {
      _that.setState({
        teams: (FakeData.getData("yoo")) ? FakeData.getData("yoo").ownTeams : []
      });
    }), 1000)
  }

  componentWillUnmount() {
    clearInterval(this.getDataID)
  }

  handleKeyup(e) {
    const val = e.target.value
    const newList = []
    this.state.teams.forEach((item) => {
      if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
        newList.push(item)
      }
    })

    this.setState({
      value: val,
      filteredData: newList
    })
  }

  onClose() {
    this.setState({
      isModalOpen: false
    });
  }

  selectTeam(team) {
    if (this.props.isMulti) {
      const { teamArr } = this.state;
      const filter_ = teamArr.filter((item, i) => {
        return item.id === team.id && item.activeSquad.id === team.activeSquad.id;
      })
      if (filter_.length > 0) {
        const _teams = teamArr.filter((item, i) => {
          return item.id !== team.id && item.activeSquad.id !== team.activeSquad.id;
        })

        this.setState({ teamArr: _teams });

      } else {
        teamArr.push(team);
        this.setState({ teamArr });
      }
    } else {
      this.onClose()
      this.props.onTeamSelect(team)
    }
  }

  inTeams = (team) => {
    const { teamArr } = this.state;
    const filter_ = teamArr.filter((item, i) => {
      return item.id === team.id && item.activeSquad.id === team.activeSquad.id;
    })

    if (filter_.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  setUserToInvite(user) {
    this.setState({
      userTo: user,
      userError: false
    });
  }

  emailChange(e) {
    const val = e.target.value
    if ((val.indexOf("@") <= -1) || (val.indexOf(".") <= -1)) {
      this.setState({
        emailError: true,
        emailTo: val
      });
    } else {
      this.setState({
        emailError: false,
        emailTo: val
      });
    }
  }

  nameChange(e) {
    this.setState({
      teamName: e.target.value,
      teamError: false
    });
  }

  addTeam() {
    if ((this.state.teamName == "") || (this.state.teamName == null)) {
      this.setState({
        teamError: true
      });

      return
    }

    if ((this.state.emailTo == "") || (this.state.emailTo == null)) {
      this.setState({
        emailError: true
      });

      return
    }

    if (this.state.userTo == null) {
      this.setState({
        userError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      userTo: this.state.userTo,
      teamName: this.state.teamName,
      emailTo: this.state.emailTo
    }

    const _that = this

    FakeData.post('/registerGhostTeam.php?auth0', dataTo, {
      success: ((data) => {
        _that.selectTeam(data)
        _that.setState({
          isModalOpen: false
        });
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    return (
      <div>
        <input placeholder="Select a team..." value={this.props.value} readOnly style={{ width: "100%", padding: "4px" }} onClick={() => {
          this.setState({
            isModalOpen: true
          });
        }} />
        <Modal isOpen={this.state.isModalOpen} onClose={() => {
          this.setState({
            isModalOpen: false
          });
        }}>
          <div className="add-team">
            <h1>Pick A Team</h1>
            <button className="button" onClick={() => this.setState({
              isAddingNew: true
            })}>Add Team</button>
            <div>
              <input onKeyUp={(e) => this.handleKeyup(e)} style={{ width: "100%", margin: "0px 0px 10px" }} placeholder="Enter a team name" />
              <div style={{ maxHeight: "300px", padding: "0px 0px 20px 0px", overflowY: "auto" }}>
                {
                  this.state.filteredData.map((item, i) =>
                    <div className="add-team-item" style={{ background: (this.props.isMulti && this.inTeams(item)) ? "#4ac" : "", color: (this.props.isMulti && this.inTeams(item)) ? "#fff" : "" }} key={i} onClick={() => this.selectTeam(item)}>
                      <img src={item.image} />
                      <span>{item.name}</span>
                    </div>
                  )
                }
              </div>
            </div>
            {this.props.isMulti &&
              <button className="button" onClick={() => {
                this.onClose();
                this.props.onTeamSelect(this.state.teamArr)
              }}>Add Team</button>
            }
          </div>

          <Modal isOpen={this.state.isAddingNew} onClose={() => this.setState({
            isAddingNew: false
          })}>
            <div className="add-a-team">
              <h1>Add A Team</h1>
              <div className="input-field">
                <span>Team Name</span>
                <input value={this.state.teamName} onChange={this.nameChange} className={(this.state.teamError) ? 'error' : ''} />
              </div>
              <div className="input-field">
                <ItemPicker isExtended="true" user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={this.setUserToInvite} width="27.85em" label="Name" data={FakeData.getData("yoo").friends} />
              </div>
              <div className="input-field">
                <span>Validation Email</span>
                <input value={this.state.emailTo} onChange={this.emailChange} className={(this.state.emailError) ? 'error' : ''} />
              </div>
              <button onClick={this.addTeam}>Add</button>
            </div>
          </Modal>
        </Modal>
      </div>
    );
  }
}

export class LocationPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      isModalOpen: false,
      lon: "",
      lat: "",
      name: "",
      address: ""
    }

    this.addPlace = this.addPlace.bind(this)
    this.setValue = this.setValue.bind(this)
    this.setPlace = this.setPlace.bind(this)
  }

  setPlace(e) {
    var val = (e.name) ? e.name : e
    this.props.onSetPlace(e)
    this.setState({
      value: val,
      isModalOpen: false
    });
  }

  setValue(key, e) {
    switch (key) {
      case "name":
        this.setState({
          name: e.target.value,
          nameError: false
        });
        break;
      case "address":
        this.setState({
          address: e.target.value,
          addressError: false
        });
        break;
      case "lon":
        this.setState({
          lon: e.target.value,
          lonError: false
        });
        break;
      case "lat":
        this.setState({
          lat: e.target.value,
          latError: false
        });
        break;
      default:

    }
  }

  addPlace() {
    const _that = this
    if ((this.state.name == "") || (this.state.name == null)) {
      this.setState({
        nameError: true
      });

      return
    }

    if ((this.state.address == "") || (this.state.address == null)) {
      this.setState({
        addressError: true
      });

      return
    }

    if ((this.state.lon == "") || (this.state.lon == null)) {
      this.setState({
        lonError: true
      });

      return
    }

    if ((this.state.lat == "") || (this.state.lat == null)) {
      this.setState({
        latError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      lon: this.state.lon,
      address: this.state.address,
      lat: this.state.lat,
      name: this.state.name
    }

    FakeData.post('/createPlace.php?auth0', dataTo, {
      success: ((data) => {
        _that.setPlace(data)
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    if (this.props.embed) {
      return (
        <div className={(this.props.classes) ? this.props.classes : ""}>
          <ComboBox user={this.props.user} label="Location" width="27.85em" onSelectedItem={this.setPlace} placeholder={(this.state.value != '') ? this.state.value : "Select a location"} data={this.props.places} />
          <span style={{ display: "block", textAlign: "center", fontSize: "10px", color: "#888" }}>OR</span>
          <div className="input-field">
            <span>City</span>
            <input className={(this.state.nameError) ? 'error' : ''} onChange={(e) => this.setValue('name', e)} value={this.state.name} style={{ padding: "4px" }} />
          </div>
          <div className="input-field">
            <span>Address</span>
            <input className={(this.state.addressError) ? 'error' : ''} onChange={(e) => this.setValue('address', e)} value={this.state.address} style={{ padding: "4px" }} />
          </div>

          <div className="split-input">
            <div className="input-field">
              <span>Longitude</span>
              <input type="number" className={(this.state.lonError) ? 'error' : ''} onChange={(e) => this.setValue('lon', e)} value={this.state.lon} style={{ padding: "4px" }} />
            </div>
            <div className="input-field">
              <span>Latitude</span>
              <input type="number" className={(this.state.latError) ? 'error' : ''} onChange={(e) => this.setValue('lat', e)} value={this.state.lat} style={{ padding: "4px" }} />
            </div>
          </div>
          <button onClick={this.addPlace} className="button">Add Place</button>
        </div>
      )
    }
    return (
      <div className={(this.props.classes) ? this.props.classes : ""}>
        <input className={this.props.inputClass ? this.props.inputClass : ""} placeholder={(this.state.value !== "") ? this.state.value : this.props.value} readOnly style={{ width: "100%", padding: "4px" }} onClick={() => {
          this.setState({
            isModalOpen: true
          });
        }} />
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({
          isModalOpen: false
        })}>
          <div className="add-place">
            <h1>Add Place</h1>
            <ComboBox user={this.props.user} label="Location" width="27.85em" onSelectedItem={this.setPlace} placeholder={(this.state.value != '') ? this.state.value : "Select a location"} data={this.props.places} />
            <br />
            <span style={{ display: "block", textAlign: "center", fontSize: "10px", color: "#888" }}>OR</span>
            <br />
            <div className="input-field">
              <span>City</span>
              <input className={(this.state.nameError) ? 'error' : ''} onChange={(e) => this.setValue('name', e)} value={this.state.name} />
            </div>
            <div className="input-field">
              <span>Address</span>
              <input className={(this.state.addressError) ? 'error' : ''} onChange={(e) => this.setValue('address', e)} value={this.state.address} />
            </div>

            <div className="split-input">
              <div className="input-field">
                <span>Longitude</span>
                <input type="number" className={(this.state.lonError) ? 'error' : ''} onChange={(e) => this.setValue('lon', e)} value={this.state.lon} />
              </div>
              <div className="input-field">
                <span>Latitude</span>
                <input type="number" className={(this.state.latError) ? 'error' : ''} onChange={(e) => this.setValue('lat', e)} value={this.state.lat} />
              </div>
            </div>
            <button onClick={this.addPlace}>Add Place</button>
          </div>
        </Modal>
      </div>
    )
  }
}

export class EventMessageModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subject: "",
      value: "",
      msg: ""
    }
  }

  onClose() {
    this.props.onClose()
  }

  onSend() {
    if (this.props.isGroup) {
      if (this.state.subject === "") {
        this.setState({
          subjectError: true
        });

        return
      }

      if (this.state.msg === "") {
        this.setState({
          msgError: true
        });

        return
      }
    } else {
      const to = (this.props.value === "") ? this.state.value : this.props.value
      if (to === "") {
        alert("Please Enter Email")
        this.setState({
          emailError: true
        });
        return
      }

      if (this.state.subject === "") {
        this.setState({
          subjectError: true
        });

        return
      }

      if (this.state.msg === "") {
        this.setState({
          msgError: true
        });

        return
      }
    }

    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo"),
      userToId: this.props.eventToID,
      userToType: this.props.eventToType,
      isGroup: (this.props.isGroup) ? true : false,
      users: this.props.players,
      value: (this.props.value === "") ? this.state.value : this.props.value,
      subject: this.state.subject,
      msg: this.state.msg
    }

    FakeData.post("/sendEventMail.php?auth0", dataTo, {
      success: ((res) => {
        _that.onClose()
      }),
      error: ((err) => {

      })
    }, true, "Email Sent!", ((d) => {

    }))
  }

  render() {
    const sendTo = FakeData.getData("eventMailTo");
    return (
      <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
        <div className="add-place send-event-msg">
          <div className="send-event-msg-header">
            <div className="send_msg_btn" onClick={() => this.onSend()} />
            <div className="send-event-msg-header-fields">
              <div className="send-event-msg-header-field">
                <span>To</span>
                {(this.props.value !== "") &&
                  <input value={this.props.value} readOnly />
                }
                {(this.props.value === "") &&
                  <input placeholder="Email" value={this.state.value} className={(this.state.mailError) ? "error" : ""} onChange={(e) => {
                    this.setState({
                      value: e.target.value,
                      emailError: (e.target.value.indexOf("@") > -1 || e.target.value.indexOf(".") > -1) ? false : true
                    });
                  }} />
                }
              </div>
              <div className="send-event-msg-header-field">
                <span>Subject</span>
                <input placeholder="Subject" className={(this.state.subjectError) ? "error" : ""} value={this.state.subject} onChange={(e) => {
                  this.setState({
                    subject: e.target.value,
                    subjectError: false
                  });
                }} />
              </div>
            </div>
          </div>
          <textarea value={this.state.msg} className={(this.state.msgError) ? "error" : ""} placeholder="Message" onChange={(e) => {
            this.setState({
              msg: e.target.value,
              msgError: false
            });
          }} />
        </div>
      </Modal>
    );
  }
}

class AddEventModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "Create Single Event",
      tabs: ["Create Single Event", "Create Recurring Event"]
    }
  }

  setTab(item) {
    this.setState({
      activeTab: item
    });
  }

  onClose() {
    this.props.onClose()
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
        <div className="event-list-view" style={{ width: "1000px" }}>
          <div className="event-list-view-tabs">
            {
              this.state.tabs.map((item, i) => {
                return (
                  <div key={i} className={(this.state.activeTab === item) ? "event-list-view-tab active" : "event-list-view-tab"} onClick={() => {
                    this.setTab(item)
                  }}>{item}</div>
                )
              })
            }
          </div>
          <div className="event-list-view-content" style={{ padding: "20px" }}>
            {(this.state.activeTab === "Create Single Event") &&
              <EventViewCreateForm1 eventToType={this.props.eventToType} eventToID={this.props.eventToID} onAfterAdd={() => this.onClose()} />
            }

            {(this.state.activeTab === "Create Recurring Event") &&
              <EventViewCreateForm2 eventToType={this.props.eventToType} eventToID={this.props.eventToID} onAfterAdd={() => this.onClose()} />
            }
          </div>
        </div>
      </Modal>
    );
  }
}

export class EditEventModal extends Component {
  constructor(props) {
    super(props)

  }

  onClose() {
    this.props.onClose()
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} onClose={() => this.onClose()}>
        <div style={{ width: "1000px", padding: "20px" }}>
          <EventViewCreateForm1 isEditting="true" event={this.props.event} eventToType={this.props.eventToType} eventToID={this.props.eventToID} onAfterAdd={() => this.onClose()} />
        </div>
      </Modal>
    );
  }
}


export class CreateNormalEvent extends Component {
  constructor(props) {
    super(props);

  }

  render = () => {
    return (
      <Modal isOpen={true} onClose={() => { }}>
        <div className="add-place" style={{ width: "40vw" }}>

        </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Event.js